import React, { Component } from 'react';
import 'HELPDESK/Components/QueryDetails/querydetails.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import { Base64 } from 'js-base64';
import axios from 'axios';
import Pagination from 'react-js-pagination';
import ReactHtmlParser from 'react-html-parser';
import Spinner from 'HELPDESK/CommonResources/SpinnerLoader/Spinner';
import ReactQuill from 'react-quill';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
// import Carousel from 'react-bootstrap/Carousel';
import magicIC from 'HELPDESK/CommonResources/images/services/magic.png';
import timeIC from 'HELPDESK/CommonResources/images/services/timeIC.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import comingSoonGIf from 'HELPDESK/CommonResources/images/services/comingSoon.gif';
import defaultIc from 'HELPDESK/CommonResources/images/services/defaultIc.png';
import deliveredGif from 'HELPDESK/CommonResources/images/services/delievered.gif';
import viewBTNGif from 'HELPDESK/CommonResources/images/services/viewBTN.gif';
import animatedDot from 'HELPDESK/CommonResources/images/services/animatedDot.gif';
import alarmGif from 'HELPDESK/CommonResources/images/animation-red.gif';
import rightArrowGif from 'HELPDESK/CommonResources/images/services/rightArrow.gif';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import dotPng from 'HELPDESK/CommonResources/images/services/dot.png';

import { Typewriter } from 'react-simple-typewriter'

import classicIC from "HELPDESK/CommonResources/images/classic.png";
import premiumIC from "HELPDESK/CommonResources/images/premium.png";
import enterpriseIC from "HELPDESK/CommonResources/images/enterprise.png";
import activeIc from 'HELPDESK/CommonResources/images/active.svg';
import inactiveIc from 'HELPDESK/CommonResources/images/unactive.svg';
import selectedIC from 'HELPDESK/CommonResources/images/selected.svg';
import AddRequestModal from './AddRequestModal/AddRequestModal';
import ViewRequestModal from './ViewRequestModal/ViewRequestModal';

class QueryDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET Service Request DETAILS
            activeTab: "errors",
            queryListFetching: false,
            queryList: {},
            pageIndex: 1,
            limit: 15,
            offset: 0,
            queryCount: 0,
            querySequence: [],
            releaseUpdateList: {},

            subscriptionModuleList: {},
            selectedModuletab: "Employee Registration",
            items: [],
            hasMore: true,
            moduleId: 10,
            addSubModuleList: {},
            addQuery: false,


            addingQuery: false,
            loadingUpdates: false,
            // moduleId: '',
            moduleName: '',
            moduleWarning: '',
            queryType: '',
            queryTypeWarning: '',
            accountType: '',
            accountTypeWarning: '',
            queryTitle: '',
            queryTitleWarning: '',
            queryDescription: '',
            queryDescriptionWarning: '',
            queryOccurrence: [],
            queryOccurrenceWarning: '',
            queryAttachments: [],
            attachmentSizeWarning: '',
            attachmentTypeWarning: '',
            subModuleName: '',
            subModuleWarning: '',
            subModuleId: '',
            addSubModuleList: [],
            filterModuleId: "",

            // VARIABLES TO VIEW Service Request DETAILS
            viewQuery: false,
            currentQueryIndex: '',
            currentQueryId: '',
            selectedModuleId: 0,
            selectedModuleName: '',
            viewSprintModal: false,
            currentModuleIndex: '',
            viewModuleType: '',
            queryDetailsFetching: false,
            queryDetails: {},

            sprintDetails: {},
            individualSprintData: [],

            correspondencePageIndex: 1,
            correspondenceLimit: 10,
            correspondenceCount: 0,
            viewQueryType: '',
            individualQueryFetching: false,
            correspondenceComments: {},
            correspondenceSequence: [],
            currentCommentTab: 'correspondence',
            queryInstituteId: '',
            filterServiceRequest_Number: "",
            selectedModule: '',

            // VARIABLES TO ADD / UPDATE COMMENT
            correspondenceComment: '',
            correspondenceAttachments: [],
            correspondenceAttachedFiles: [],
            correspondenceCommentWarning: '',
            addingCorrespondenceComment: false,
            updateCorrespondenceComment: false,
            commentResponseType: '',
            commentResponseMessage: '',

            // VARIABLES TO VIEW ATTACHMENT
            viewAttachment: false,
            attachmentPath: '',
            attachmentFile: '',
            attachmentFileExtension: '',

            // open : Boolean(this.state.anchorEl),
            idSearchByDate: 'false',
            successMessage: "",
            activeInfo: false,
            FilterEndDate: "",
            FilterStartDate: "",
            selectedSprintId: 0,
            selectedTitleInfo: "",
            selectedStartDate: "",
            selectedEndDate: "",
            sprintLoader: false,
            selectedSprintObj: {},
            showSprintAttachment: false,

            markAsResolvedApiStarted: false,

            viewStatusConfirmModal: false,

            viewReopenConfirmationModal: false,

            currentModule: "Employee Registration",
            serviceReqFetch: false,
            serviceReqList: {},
            serviceReqSequence: [],
            serviceReqCount: 0,
            sevicePageIndex: 1,
            serviceLimit: 10,
            serviceItems: [],
            hasMoreServiceReq: true,
            serviceoffset: 0,



            //  Live update screen states
            showLiveUpdateView: false,

            subscriptionType: "",
            searchKey: "",
            filteredPhase: "",
            filteredModuleId: "",
            filteredModuleName: "",
            totalVisits: 0,
            completedVisits: 0,
            phaseDetails: {},
            moduleDetails: {},
            updatedModuleDetails: {},
            clientSubscribedModuleIds: [],
            moduleList: {},
            onboardingStepFetching: false,
            fetchingModuleDetails: false,
            selectModules: false,
            modulesFetching: false,
            staticPhaseDetails: {
                "33": {
                    moduleId: "33",
                    phase: "phase1"
                },
                "10": {
                    moduleId: "10",
                    phase: "phase1"
                },
                "11": {
                    moduleId: "11",
                    phase: "phase1"
                },
                "12": {
                    moduleId: "12",
                    phase: "phase2"
                },
                "16": {
                    moduleId: "16",
                    phase: "phase2"
                },
                "15": {
                    moduleId: "15",
                    phase: "phase2"
                },
                "20": {
                    moduleId: "20",
                    phase: "phase2"
                },
                "39": {
                    moduleId: "39",
                    phase: "phase3"
                },
                "21": {
                    moduleId: "21",
                    phase: "phase3"
                },
                "42": {
                    moduleId: "42",
                    phase: "phase3"
                },
                "29": {
                    moduleId: "29",
                    phase: "phase3"
                },
                "27": {
                    moduleId: "27",
                    phase: "phase3"
                },
                "19": {
                    moduleId: "19",
                    phase: "phase3"
                },
                "31": {
                    moduleId: "31",
                    phase: "phase3"
                },
                "28": {
                    moduleId: "28",
                    phase: "phase3"
                },
                "30": {
                    moduleId: "30",
                    phase: "phase3"
                },
                "53": {
                    moduleId: "53",
                    phase: "phase3"
                },
                "35": {
                    moduleId: "35",
                    phase: "phase3"
                },
                "32": {
                    moduleId: "32",
                    phase: "phase3"
                },
                "26": {
                    moduleId: "26",
                    phase: "phase4"
                },
                "25": {
                    moduleId: "25",
                    phase: "phase4"
                },
                "23": {
                    moduleId: "23",
                    phase: "phase4"
                },
                "44": {
                    moduleId: "44",
                    phase: "phase4"
                },
                "43": {
                    moduleId: "43",
                    phase: "phase4"
                }
            },
            openQueryModal: false,
            currentQueryRequestId: null,
            currentRequest: {},
            ccList: {},
            isCCAdminMember: "false",
            userQueryType: ""
        };
    }


    componentDidMount() {
        this.apiCallToGetModuleWiseCCApprovalPendingRequests();
        this.apiCallToSubscriptionModuleList();

        // Call API to fetch module list
        this.apiCallToGetModuleList();

        // Call API to fetch assigned activity or module
        this.apiCallToGetAssignedActivityOrModule();

        // METHOD CALLED TO GET Service Request(s) LIST
        this.apiCallToGetLiveUpdates();
        this.apiCallToGetQueries();
        this.apiCallToGetAddSubModuleList();
        this.apiCallToGetServiceReqQuery();

    }
    // API METHOD CALL TO CHECK INSTITUTE
    apiCallToCheckUserStatus = async () => {
        this.setState({
            checkingInstituteStatus: true
        });

        let requestData = {
            "iid": config.institute_id,

        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'HelpDeskCheckUserStatus',
            requestData,
            '/api/helpDesk/employee/Queries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToCheckUserStatus()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let status = jsonResponse.APIResult.status;
                if (status == "failed") {
                    this.setState({
                        checkingInstituteStatus: false,
                        // addQuery: true 

                    });
                    toast.warning(jsonResponse.APIResult.message)
                } else {
                    this.setState({
                        checkingInstituteStatus: false,
                        addQuery: true
                    });
                }
            } else {
                this.setState({
                    checkingInstituteStatus: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting user queries. Please try again later.'
                });
            }
        }
    }
    // 

    componentDidUpdate(prevProps, prevState) {
        if (
            (prevState.addQuery !== this.state.addQuery) ||
            (prevState.openQueryModal !== this.state.openQueryModal)
        ) {
            this.apiCallToGetServiceReqQuery();
            this.apiCallToGetModuleWiseCCApprovalPendingRequests();
        }
    }

    // 
    apiCallToGetServiceReqQuery = async () => {
        this.setState({
            serviceReqFetch: true,
        });

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.sevicePageIndex,
            "limitPerPage": this.state.serviceLimit,
            "InstructorId": config.faculty_id,
            "filterStatus": "",
            "filter_module_array": this.state.moduleId != "" ? [this.state.moduleId] : [],
            "filterServiceRequest_Number": this.state.filterServiceRequest_Number,
            "UserQueryType": "",
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetUserQueries',
            requestData,
            '/api/helpDesk/employee/Queries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetServiceReqQuery()
            }, 1000);
        } else {


            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState(prev => ({
                    serviceReqFetch: false,
                    serviceItems: [...prev.serviceItems, ...Object.values(apiResult)],
                    serviceReqList: apiResult,
                    serviceReqSequence: jsonResponse.APIResult.SequenceIdArray,
                    serviceReqCount: jsonResponse.APIResult.query_count,
                    // querySequence: jsonResponse.APIResult.SequenceIdArray
                }));



            } else {
                this.setState({
                    serviceReqFetch: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting service request list. Please try again later.'
                });
            }
        }
    }



    apiCallToGetModuleWiseCCApprovalPendingRequests = async () => {
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'helpDesk_getModuleWiseCCApprovalPendingRequests',
            requestData,
            '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleWiseCCApprovalPendingRequests()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;


                this.setState({
                    ccList: apiResult,
                });





            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting subscription module list. Please try again later.'
                });
            }
        }
    }

    apiCallToSubscriptionModuleList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMCurrentSubscriptionWiseModuleList',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToSubscriptionModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let selectedModuletab = this.state.selectedModuletab;
                selectedModuletab = "";
                let moduleId = this.state.moduleId;
                moduleId = "";

                if (Object.keys(apiResult).length > 0) {
                    selectedModuletab = Object.values(apiResult)[0]['module_name'];
                    moduleId = Object.values(apiResult)[0]['moduleId'];
                }

                this.setState({
                    subscriptionModuleList: apiResult,
                    selectedModuletab,
                    moduleId
                });



            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting subscription module list. Please try again later.'
                });
            }
        }
    }



    apiCallToGetAddSubModuleList = async () => {
        let requestData = {
            'module_id': this.state.moduleId
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getHelpDeskSubModulesList',
            requestData,
            '/api/helpDesk/employee/Queries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAddSubModuleList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    addSubModuleList: apiResult
                });
            } else {

                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting sub module list. Please try again later.'
                });
            }
        }
    }
    // API METHOD CALL TO GET Service Request(s) LIST
    apiCallToGetQueries = async () => {

        this.setState({
            queryListFetching: true,

        });

        let requestData = {
            "institute_id": config.institute_id,
            "page_index": this.state.pageIndex,
            "limit": this.state.limit,
            "assistance_type": "Daily Updates",
            "module_name": [`${this.state.selectedModuletab}`]
            // "filterStatus": this.state.status,
            // "filter_module_array": this.state.filterModuleId != "" ? [this.state.filterModuleId] : [],
            // "filterServiceRequest_Number": this.state.filterServiceRequest_Number,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getAssistanceTypeUpdatesListForSummaryPage',
            requestData,
            '/api/dailyUpdates/dailyUpdate.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetQueries()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState(prev => ({
                    queryListFetching: false,
                    queryList: apiResult,
                    items: [...prev.items, ...Object.values(apiResult)],
                    queryCount: jsonResponse.APIResult.totalCount,
                    //querySequence: jsonResponse.APIResult.SequenceIdArray
                }));
            } else {
                this.setState({
                    queryListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting service request list. Please try again later.'
                });
            }
        }
    }

    onEnterCall = (e) => {
        if (e.key === 'Enter') {
            this.setState({
                sevicePageIndex: 1
            },
                () => this.apiCallToGetServiceReqQuery()
            );
        }
    }

    handleCloseViewRequestModal = () => {
        this.setState({
            openQueryModal: false
        });
    }

    // METHOD TO SELECT SUB MODULE
    selectAddSubModule = (e) => {
        this.setState({
            subModuleId: e.target.value,
        });


        if (e.target.value.length < 1) {
            this.setState({
                subModuleName: '',
                subModuleWarning: 'Please select sub module.'
            });
        } else {
            this.setState({
                subModuleName: e.target.selectedOptions[0].text,
                subModuleWarning: ''
            });
        }
    }
    // METHOD TO GET Service Request TITLE
    getQueryTitle = (e) => {
        this.setState({
            queryTitle: e.target.value
        });

        if (e.target.value.length < 1) {
            this.setState({
                queryTitleWarning: 'Service request title cannot be empty.'
            });
        } else {
            this.setState({
                queryTitleWarning: ''
            });
        }
    }

    // METHOD TO GET Service Request DESCRIPTION
    getQueryDescription = (e) => {
        this.setState({
            queryDescription: e.target.value
        });

        if (e.target.value.length < 1) {
            this.setState({
                queryDescriptionWarning: 'Service request description cannot be empty.'
            });
        } else {
            this.setState({
                queryDescriptionWarning: ''
            });
        }
    }

    // METHOD TO SELECT Service Request TYPE
    getQueryType = (e) => {
        this.setState({
            queryType: e.target.value
        });

        if (e.target.value.length < 1) {
            this.setState({
                queryTypeWarning: 'Please select service request type.'
            });
        } else {
            this.setState({
                queryTypeWarning: ''
            });
        }
    }

    getAccountType = (e) => {
        this.setState({
            accountType: e.target.value
        });

        if (e.target.value.length < 1) {
            this.setState({
                accountTypeWarning: 'Please select account type.'
            });
        } else {
            this.setState({
                accountTypeWarning: ''
            });
        }
    }

    // METHOD TO SELECT Service Request OCCURRENCE
    selectOccurrence = (e, occurrence) => {
        let queryOccurrence = this.state.queryOccurrence;

        if (e.target.checked) {
            queryOccurrence = [];
            queryOccurrence.push(occurrence);
        }
        else {
            queryOccurrence = [];
        }

        // if(queryOccurrence.includes(occurrence)) {
        //     queryOccurrence = queryOccurrence.filter(occur => occur != occurrence);
        // }else {
        //     queryOccurrence.push(occurrence);
        // }

        if (queryOccurrence.length < 1) {
            this.setState({
                queryOccurrenceWarning: 'Please select service request occurred in.'
            });
        } else {
            this.setState({
                queryOccurrenceWarning: ''
            });
        }

        this.setState({
            queryOccurrence
        });
    }

    // METHOD TO CLICK Service Request ATTACHMENT INPUT
    clickQueryAttachment = () => {
        document.getElementById('queryAttachment').click();
    }

    // METHOD TO GET Service Request ATTACHMENT FILES
    getQueryAttachments = (e) => {
        let files = e.target.files;
        this.setState({
            queryAttachments: Object.values(e.target.files)
        });

        if (files.length > 0) {
            Object.values(files).map(file => {
                let allowedExtension = /(\.exe|\.php|\.js|\.cpp|\.c|\.java)$/i;
                if (allowedExtension.exec(file.name)) {
                    this.setState({
                        attachmentTypeWarning: '.exe, .php, .js, .cpp, .c, .java. extension files are not allowed.'
                    });
                } else {
                    if ((file.size / 1048576.0) > 50) {
                        this.setState({
                            attachmentSizeWarning: 'Please select file less than 50MB.'
                        });
                    } else {
                        this.setState({
                            attachmentSizeWarning: '',
                        });
                    }

                    this.setState({
                        attachmentTypeWarning: ''
                    });
                }
            });
        }
    }

    // METHOD TO REMOVE SELECTED FILE
    removeSelectedFile = (fileIndex) => {
        let queryAttachments = this.state.queryAttachments;
        queryAttachments.splice(fileIndex, 1);
        this.setState({
            queryAttachments
        });
    }

    // METHOD TO VALIDATE Service Request DETAILS
    validateQueryDetails = () => {
        let validData = true;

        if (this.state.moduleId.length < 1) {
            this.setState({
                moduleWarning: 'Please select module.'
            });
            validData = false;
        }
        if (this.state.subModuleId.length < 1) {
            this.setState({
                subModuleWarning: 'Please select sub module.'
            });
            validData = false;
        }

        if (this.state.queryTitle.length < 1) {
            this.setState({
                queryTitleWarning: 'Service request title cannot be empty.'
            });
            validData = false;
        }

        if (this.state.queryDescription.length < 1) {
            this.setState({
                queryDescriptionWarning: 'Service request description cannot be empty.'
            });
            validData = false;
        }

        if (this.state.queryType.length < 1) {
            this.setState({
                queryTypeWarning: 'Please select service request type.'
            });
            validData = false;
        }
        if (this.state.accountType.length < 1) {
            this.setState({
                accountTypeWarning: 'Please select account type.'
            });
            validData = false;
        }

        if (this.state.queryOccurrence.length < 1) {
            this.setState({
                queryOccurrenceWarning: 'Please select service request occurred in.'
            });
            validData = false;
        }

        if (validData) {
            // METHOD CALLED TO ADD Service Request
            this.apiCallToAddQuery();
        }
    }

    // API CALL METHOD TO ADD Service Request
    apiCallToAddQuery = async () => {
        this.setState({
            addingQuery: true
        });

        let formData = new FormData();

        formData.append('PostQueryFromHelpDesk', true);
        formData.append('data', Base64.encode(JSON.stringify({
            "userRole": "Instructor",
            "useruid": config.faculty_id,
            "iid": config.institute_id,
            "querySubject": this.state.queryTitle,
            "queryDescription": this.state.queryDescription,
            "moduleName": this.state.moduleName,
            "moduleId": this.state.moduleId,
            "Query_occurred_in_array": this.state.queryOccurrence,
            "acyar": config.instructorInfo.AcaYearId,
            "queryType": this.state.queryType,
            "subModuleId": this.state.subModuleId,
            "accountType": this.state.accountType,
        })));

        if (this.state.queryAttachments.length > 0) {
            this.state.queryAttachments.map(attachment => {
                formData.append('file[]', attachment);
            });
        } else {
            formData.append('file[]', []);
        }

        let parameterData = JSON.stringify({
            source: 'app',
            uid: config.faculty_id,
            email: config.emailId,
            role: 'instructor'
        });

        formData.append('tokenInputParameter', Base64.encode(parameterData));

        const headers = {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Authorization": "Basic " + config.user_token
        };

        await axios.post(
            config.RootUrl + '/api/helpDesk/employee/Queries.php',
            formData,
            {
                headers: headers,
            }
        ).then(response => {
            if (response.data.success) {
                response = response.data;
                if (response.status == 'success') {
                    let queryList = this.state.queryList;
                    let querySequence = this.state.querySequence;
                    if (this.state.queryType != 'New Change Request') {
                        if (response.insertedQueryId.length > 1) {
                            response.insertedQueryId.map((queryId, queryIndex) => {
                                if (queryIndex == 0) {
                                    if (queryList[queryId] == undefined) {
                                        queryList[queryId] = {};
                                    }
                                    queryList[queryId]['uniqueid'] = queryId;
                                    queryList[queryId]['userQuery'] = this.state.queryTitle;
                                    queryList[queryId]['userQueryType'] = this.state.queryType;
                                    queryList[queryId]['status'] = 'open';
                                    queryList[queryId]['moduleName'] = this.state.moduleName;
                                    queryList[queryId]['subModuleId'] = this.state.subModuleId;
                                    queryList[queryId]['subModuleName'] = this.state.subModuleName;
                                    queryList[queryId]['accountType'] = this.state.accountType;
                                    queryList[queryId]['moduleId'] = this.state.moduleId;
                                    queryList[queryId]['description'] = this.state.queryDescription;
                                    queryList[queryId]['userUniqueId'] = config.faculty_id;
                                    queryList[queryId]['iid'] = config.institute_id;
                                    queryList[queryId]['query_occurred_in'] = 'Web Portal';
                                    queryList[queryId]['subQuery'] = {};

                                    querySequence.push(queryId);

                                } else {
                                    if (queryList['subQuery'] == undefined) {
                                        queryList['subQuery'] = {};
                                    }

                                    if (queryList['subQuery'][queryId] == undefined) {
                                        queryList['subQuery'][queryId] = {};
                                    }

                                    queryList['subQuery'][queryId]['uniqueid'] = queryId;
                                    queryList['subQuery'][queryId]['userQuery'] = this.state.queryTitle;
                                    queryList['subQuery'][queryId]['userQueryType'] = this.state.queryType;
                                    queryList['subQuery'][queryId]['status'] = 'open';
                                    queryList['subQuery'][queryId]['moduleName'] = this.state.moduleName;
                                    queryList['subQuery'][queryId]['moduleId'] = this.state.moduleId;
                                    queryList['subQuery'][queryId]['description'] = this.state.queryDescription;
                                    queryList['subQuery'][queryId]['userUniqueId'] = config.faculty_id;
                                    queryList['subQuery'][queryId]['iid'] = config.institute_id;
                                    queryList['subQuery'][queryId]['subModuleId'] = this.state.subModuleId;
                                    queryList['subQuery'][queryId]['subModuleName'] = this.state.subModuleName;
                                    queryList['subQuery'][queryId]['query_occurred_in'] = queryIndex == 1 ? 'Android Application' : 'IOS Application';
                                }
                            })
                        } else {
                            response.insertedQueryId.map(queryId => {
                                if (queryList[queryId] == undefined) {
                                    queryList[queryId] = {};
                                }
                                queryList[queryId]['uniqueid'] = queryId;
                                queryList[queryId]['userQuery'] = this.state.queryTitle;
                                queryList[queryId]['userQueryType'] = this.state.queryType;
                                queryList[queryId]['status'] = 'open';
                                queryList[queryId]['moduleName'] = this.state.moduleName;
                                queryList[queryId]['moduleId'] = this.state.moduleId;
                                queryList[queryId]['subModuleId'] = this.state.subModuleId;
                                queryList[queryId]['subModuleName'] = this.state.subModuleName;
                                queryList[queryId]['description'] = this.state.queryDescription;
                                queryList[queryId]['userUniqueId'] = config.faculty_id;
                                queryList[queryId]['iid'] = config.institute_id;
                                queryList[queryId]['query_occurred_in'] = 'Web Portal';
                                queryList[queryId]['subQuery'] = {};

                                querySequence.push(queryId);

                            })
                        }
                    }
                    this.closeAddQuery();

                    this.setState({
                        addingQuery: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: response.message,
                        queryList,
                        querySequence,
                        queryCount: this.state.queryCount + 1
                    }, () => {
                        this.apiCallToGetQueries();
                    });
                } else {
                    this.setState({
                        addingQuery: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: response.message,
                    });
                }
            } else {
                this.setState({
                    addingQuery: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding service request. Please try again later.'
                });
            }
        });
    }


    updateServicePage = (pageNumber) => {
        this.setState({
            sevicePageIndex: pageNumber,
            serviceoffset: (pageNumber - 1) * this.state.serviceLimit
        }, () => {
            this.apiCallToGetServiceReqQuery();
        });
    }

    updatePageForUpdates = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit
        }, () => {
            this.apiCallToGetQueries();
        });
    }

    closeAddQuery = () => {
        this.setState({
            addQuery: false,
            addingQuery: false,
            moduleId: this.state.moduleId,
            moduleName: '',
            moduleWarning: '',
            queryType: '',
            queryTypeWarning: '',
            queryTitle: '',
            queryTitleWarning: '',
            queryDescription: '',
            queryDescriptionWarning: '',
            queryOccurrence: [],
            queryOccurrenceWarning: '',
            queryAttachments: [],
            attachmentSizeWarning: '',
            attachmentTypeWarning: '',
            subModuleName: '',
            subModuleWarning: '',
            subModuleId: '',
            addSubModuleList: [],
        });
    }


    returnAddQuery = () => {
        return (
            <div id="addQuerySlider" style={{ display: this.state.addQuery ? 'flex' : 'none' }}>
                <div id="addQueryDataContainer">
                    <div id="addQueryHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddQuery()} style={{ cursor: "pointer" }} />
                        <h5 className="col-11">Add Service Request</h5>
                    </div>
                    <div id="addQueryBody" className="col-md-12">
                        <div className="queryModule">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Module <span style={{ color: 'red' }}>*</span></label>
                            <select
                                disabled={true}
                                style={{ fontSize: "13px" }}
                                className="form-control"
                                value={this.state.moduleId}
                                onChange={(e) => this.getModule(e)}
                            >
                                <option value="">Select Module</option>
                                {
                                    Object.keys(this.state.subscriptionModuleList).length > 0 &&
                                    Object.values(this.state.subscriptionModuleList).map(module => {
                                        return (
                                            <option key={module.moduleId} value={module.moduleId}>{module.module_name}</option>
                                        );

                                    })
                                }
                            </select>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.moduleWarning}</p>
                        </div>
                        <div className="subModuleSelection" style={{ marginTop: 10 }}>
                            <label style={{ marginBottom: 0, fontSize: 14 }}>Sub Module <span style={{ color: 'red' }}>*</span></label>
                            <select
                                className="form-control addQueryInput"
                                value={this.state.subModuleId}
                                onChange={(e) => this.selectAddSubModule(e)}
                            >
                                <option value=''>Select Sub Module</option>
                                {
                                    Object.keys(this.state.addSubModuleList).length > 0 &&
                                    Object.values(this.state.addSubModuleList).map(subModule => {
                                        return (
                                            <option key={subModule.uniqueId} value={subModule.uniqueId}>{subModule.subModuleName}</option>
                                        );
                                    })
                                }
                            </select>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.subModuleWarning}</p>
                        </div>
                        <div className="queryTitle">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Service Request Title <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="text"
                                placeholder="Enter Service Request Title"
                                className="form-control addQueryInput"
                                value={this.state.queryTitle}
                                onChange={(e) => this.getQueryTitle(e)}
                            />
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.queryTitleWarning}</p>
                        </div>
                        <div className="queryDescription">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Description <span style={{ color: 'red' }}>*</span></label>
                            <textarea
                                placeholder="Enter Description"
                                className="form-control addQueryInput"
                                value={this.state.queryDescription}
                                onChange={(e) => this.getQueryDescription(e)}
                                rows={4}
                                style={{ resize: 'none' }}
                            />
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.queryDescriptionWarning}</p>
                        </div>
                        <div className="queryType">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14, textTransform: 'none' }} className="text-muted">Type of Service Request <span style={{ color: 'red' }}>*</span></label>
                            <select
                                type="text"
                                className="form-control addQueryInput"
                                value={this.state.queryType}
                                onChange={(e) => this.getQueryType(e)}
                            >
                                <option value="">Select Service Request Type</option>
                                <option value="general Request">General Request</option>
                                <option value="Error">Change Request</option>
                                <option value="New Change Request">Customization Request</option>

                            </select>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.queryTypeWarning}</p>
                        </div>
                        <div className="queryOccurrence">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14, textTransform: 'none' }} className="text-muted">Service Request Occurred in <span style={{ color: 'red' }}>*</span> <span style={{ fontSize: 12 }}>(Select the devices in which you found the issue)</span></label>
                            <div className="webQuery">
                                <input
                                    type="radio"
                                    checked={this.state.queryOccurrence.includes('Web Portal')}
                                    onChange={(e) => this.selectOccurrence(e, 'Web Portal')}
                                    name="queryOccurrence"
                                    style={{ marginRight: 10 }}
                                />
                                <span style={{ fontSize: 14 }}>Web Portal</span>
                            </div>
                            <div className="androidQuery">
                                <input
                                    type="radio"
                                    checked={this.state.queryOccurrence.includes('Android Application')}
                                    onChange={(e) => this.selectOccurrence(e, 'Android Application')}
                                    name="queryOccurrence"
                                    style={{ marginRight: 10 }}
                                />
                                <span style={{ fontSize: 14 }}>Android Application</span>
                            </div>
                            <div className="iosQuery">
                                <input
                                    type="radio"
                                    checked={this.state.queryOccurrence.includes('IOS Application')}
                                    onChange={(e) => this.selectOccurrence(e, 'IOS Application')}
                                    name="queryOccurrence"
                                    style={{ marginRight: 10 }}
                                />
                                <span style={{ fontSize: 14 }}>IOS Application</span>
                            </div>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.queryOccurrenceWarning}</p>
                        </div>
                        <div className="queryType">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14, textTransform: 'none' }} className="text-muted">Account Type <span style={{ color: 'red' }}>*</span></label>
                            <select
                                type="text"
                                className="form-control addQueryInput"
                                value={this.state.accountType}
                                onChange={(e) => this.getAccountType(e)}
                            >
                                <option value="">Select Account Type</option>
                                <option value="faculty">Faculty</option>
                                <option value="Student">Student</option>
                                <option value="Parent">Parent</option>
                            </select>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.accountTypeWarning}</p>
                        </div>
                        <div className="queryAttachments">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14, textTransform: 'none' }} className="text-muted">Attachment(s)</label>
                            <div>
                                <input id="queryAttachment" onChange={(e) => this.getQueryAttachments(e)} type="file" style={{ display: 'none' }} multiple />
                                <button className="btn attach-button" onClick={() => this.clickQueryAttachment()}>
                                    <FontAwesomeIcon icon={['fas', 'paperclip']} style={{ marginRight: 5 }} />
                                    Choose Files
                                </button>
                                <span style={{ marginLeft: 10, fontSize: 14 }}>
                                    {
                                        this.state.queryAttachments.length > 0 &&
                                        this.state.queryAttachments.map((file, fileIndex) => {
                                            return (
                                                <p className="query-file" style={{ marginTop: 10 }}>
                                                    <p className="image-box">
                                                        {file.name.substring(file.name.lastIndexOf('.') + 1)}
                                                    </p>
                                                    <p>
                                                        <p>
                                                            {file.name}
                                                            <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeSelectedFile(fileIndex)} />
                                                        </p>
                                                        <p className="text-muted">{(file.size / 1000)} KB</p>
                                                    </p>
                                                </p>
                                            );
                                        })
                                    }
                                </span>
                            </div>
                            <p style={{ fontSize: 14 }} className='text-danger'>{this.state.attachmentSizeWarning}</p>
                            <p style={{ fontSize: 14 }} className='text-danger'>{this.state.attachmentTypeWarning}</p>
                        </div>
                    </div>
                    <div id="addQueryFooter" style={{ marginBottom: 10 }}>
                        {
                            this.state.addingQuery &&
                            <ButtonLoader />
                        }
                        <button className="btn btn-primary" onClick={() => this.validateQueryDetails()} disabled={this.state.addingQuery}>Add</button>
                        <button className="btn btn-outline-primary" style={{ backgroundColor: "white" }} onClick={() => this.closeAddQuery()}>Cancel</button>
                    </div>
                </div>
            </div >
        );
    }


    // METHOD TO VIEW Service Request DETAILS
    viewQueryDetails = (query, queryIndex, queryType) => {


        if (query.userQueryType == 'errors') {
            this.setState({
                openQueryModal: true,
                currentQueryIndex: queryIndex,
                currentQueryId: query.uniqueid,
                viewQueryType: queryType,
                currentQueryRequestId: query.uniqueid,
                currentRequest: query,
                isCCAdminMember: query.isRequestApprovalPendingByClient ?? "false",
                userQueryType: query.userQueryType
            }, () => {
                this.apiCallToGetIndividualQueryDetails();
            });

        } else if (query.userQueryType == 'designs') {
            this.setState({
                openQueryModal: true,
                currentQueryIndex: queryIndex,
                currentQueryId: query.uniqueid,
                viewQueryType: queryType,
                currentQueryRequestId: query.uniqueid,
                currentRequest: query,
                isCCAdminMember: query.isRequestApprovalPendingByClient ?? "false",
                userQueryType: query.userQueryType
            }, () => {
                this.apiCallToGetIndividualQueryDetails();
            });
        }
        else if (query.userQueryType == 'enhancements') {
            this.setState({
                openQueryModal: true,
                currentQueryIndex: queryIndex,
                currentQueryId: query.uniqueid,
                viewQueryType: queryType,
                currentQueryRequestId: query.uniqueid,
                currentRequest: query,
                isCCAdminMember: query.isRequestApprovalPendingByClient ?? "false",
                userQueryType: query.userQueryType
            }, () => {
                this.apiCallToGetIndividualQueryDetails();
            });
        }
        else {
            this.setState({
                viewQuery: true,
                currentQueryIndex: queryIndex,
                currentQueryId: query.uniqueid,
                viewQueryType: queryType
            }, () => {
                this.apiCallToGetIndividualQueryDetails();
            });

        }

    }

    // METHOD TO VIEW Service Request DETAILS
    viewModuleDetails = (query) => {
        this.setState({
            viewSprintModal: true,
            selectedModuleId: query.moduleId,
            selectedModuleName: query.moduleName
        }, () => {
            this.apiCallToGetIndividualModuleDetails();
        });

    }

    validateDate = () => {
        let endDate = this.state.FilterEndDate;
        let startDate = this.state.FilterStartDate;

        this.setState({ activeInfo: false });

        if (startDate == "" && endDate == "") {
            this.setState({
                successModal: true,
                activeInfo: false,
                successModalType: 'error',
                successMessage: 'Please select start date & end date.'
            })
        } else if (startDate == "") {
            this.setState({
                successModal: true,
                activeInfo: false,
                successModalType: 'error',
                successMessage: 'Please select start date.'
            })
        } else if (endDate == "") {
            this.setState({
                successModal: true,
                activeInfo: false,
                successModalType: 'error',
                successMessage: 'Please select end date.'
            })
        } else {
            this.apiCallToGetIndividualModuleDetails();
        }

    }



    //API call to get Individual Module List
    apiCallToGetIndividualModuleDetails = async () => {
        this.setState({ moduleLoader: true })

        // let tempModuleId = this.state.selectedModuleId;

        let requestData = {
            "filter_status": '',
            "filter_module": this.state.selectedModuleId,
            "filter_sprint": '',
            "filter_start_date": this.state.FilterStartDate,
            "filter_end_date": this.state.FilterEndDate
        }

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'HelpDeskGetDevelopmentSprints',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => { this.apiCallToGetIndividualModuleDetails() }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    moduleLoader: false,
                    sprintDetails: apiResult,
                })
            }
            else {
                this.setState({
                    moduleLoader: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting individual Module request details. Please try again later.'
                });
            }
        }
    }

    // API CALL TO GET INDIVIDUAL Service Request DETAILS
    apiCallToGetIndividualQueryDetails = async () => {
        this.setState({
            queryDetailsFetching: true
        });

        let requestData = {
            "pageIndex": this.state.correspondencePageIndex,
            "limitPerPage": this.state.correspondenceLimit,
            "queryId": this.state.currentQueryId,
            "iid": config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetIndividualQueryDetailsWithCorrespondance',
            requestData,
            '/api/helpDesk/employee/Queries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetIndividualQueryDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    queryDetailsFetching: false,
                    queryDetails: apiResult.queryDetails[this.state.currentQueryId],
                    correspondenceCount: apiResult.correspondence.comment_count,
                    correspondenceComments: apiResult.correspondence.data,
                    correspondenceSequence: apiResult.correspondence.sequenceIdArray
                });
            } else {
                this.setState({
                    queryDetailsFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting individual service request details. Please try again later.'
                });
            }
        }
    }

    // METHOD TO VIEW Service Request ATTACHMENT
    viewQueryAttachment = (query, attachment) => {
        this.setState({
            viewAttachment: true,
            attachmentPath: query.attachment_file_path,
            attachmentFile: attachment,
            attachmentFileExtension: attachment.substring(attachment.lastIndexOf('.') + 1)
        });
    }

    // METHOD TO RETURN VIEW Service Request
    returnViewQuery = () => {
        let query = this.state.queryDetails;
        let comparisonDate = ''
        if (query.allowedReopenDate != "") {
            comparisonDate = new Date(query.allowedReopenDate);
        }
        var currentDate = new Date();
        const editorStyle = {
            height: '300px', // Adjust the height as needed
        };
        return (
            <div className={this.state.viewQuery ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog viewQuery-dialog">
                    <div className="modal-content viewQuery-content">
                        <div className="modal-body viewQuery-body col-md-12">
                            {
                                this.state.individualQueryFetching ?
                                    <Spinner />
                                    :
                                    <>
                                        <div className="queryBasic-details">
                                            <div className="viewQuery-header col-md-11" style={{ paddingLeft: 0 }}>
                                                <div className="query-basic-data">
                                                    <div className="view-query-number">
                                                        <p>{query.uniqueid}</p>
                                                    </div>
                                                    {
                                                        (query.markAsEscalated != null && query.markAsEscalated == 'yes') &&
                                                        <div className="viewEscalated">
                                                            <FontAwesomeIcon icon={['fas', 'fire']} color="#EB5757" style={{ marginLeft: 20 }} />
                                                        </div>
                                                    }
                                                    {
                                                        (query.queryOccurredIn != null && query.queryOccurredIn != '') &&
                                                            query.queryOccurredIn == 'Web Portal' ?
                                                            <span>
                                                                <FontAwesomeIcon icon={['fas', 'desktop']} color="#4F4F4F" style={{ marginLeft: 20 }} />
                                                            </span>
                                                            :
                                                            query.queryOccurredIn == 'Android Application' ?
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fab', 'android']} color="#4F4F4F" style={{ marginLeft: 20 }} />
                                                                </span>
                                                                :
                                                                query.queryOccurredIn == 'IOS Application' &&
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fab', 'apple']} color="#4F4F4F" style={{ marginLeft: 20 }} />
                                                                </span>
                                                    }
                                                    {
                                                        (query.moduleName != null && query.moduleName != '') &&
                                                        <span className="viewQuery-module">
                                                            {query.moduleName}
                                                        </span>
                                                    }
                                                    <p className="viewQuery-title">
                                                        {query.userQuery != undefined && query.userQuery.length > 150 ? query.userQuery.substring(0, 150) + '...' : query.userQuery}
                                                    </p>
                                                </div>
                                                {/* <div className="query-posted-data">
                                                    <div className="posted-on-date">
                                                        <FontAwesomeIcon icon={['far', 'calendar-alt']} style={{ marginRight: 5 }} />
                                                        {query.postedOn != undefined && query.postedOn.split(' | ')[0]}
                                                    </div>
                                                    <div className="posted-on-time">
                                                        <FontAwesomeIcon icon={['far', 'clock']} style={{ marginRight: 5 }} />
                                                        {query.postedOn != undefined && query.postedOn.split(' | ')[1]}
                                                    </div>
                                                </div> */}
                                                <div className="viewQuery-transition">
                                                    <div className="viewQuery-status">
                                                        <p className="viewQuery-heading" style={{ fontSize: 14 }}>Current Status</p>
                                                        <p style={{ fontSize: 14, fontWeight: 'bold', color: '#EB5757' }}>{query.current_status}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="query-actions col-md-1" style={{ paddingRight: 0 }}>
                                                <div className="closeViewQuery">
                                                    <FontAwesomeIcon icon={['fas', 'times']} style={{ fontWeight: 'normal', cursor: 'pointer' }} size="lg" onClick={() => this.closeViewQuery()} />
                                                </div>
                                                {/* {
                                                    this.state.viewQueryType == 'query' &&
                                                        <div className="queryShift">
                                                            <FontAwesomeIcon icon={['fas', 'chevron-circle-left']} style={{ opacity: (this.state.currentQueryIndex == 0) ? 0.5 : 1, marginRight: 10, cursor: 'pointer' }} size="lg" color="#0465AC" onClick={(e) => (this.state.currentQueryIndex == 0) ? e.preventDefault() : this.getPreviousQuery()} />
                                                            <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} style={{ opacity: (this.state.currentQueryIndex == (this.state.querySequence.length - 1)) ? 0.5 : 1, cursor: 'pointer' }} size="lg" color="#0465AC" onClick={(e) => (this.state.currentQueryIndex == (this.state.querySequence.length - 1)) ? e.preventDefault() : this.getNextQuery()} />
                                                        </div>
                                                } */}
                                            </div>
                                        </div>
                                        <div className="viewQuery-description">
                                            <p style={{ fontSize: 14, fontWeight: 'bold' }}>Description</p>
                                            <p style={{ fontSize: 14, color: 'rgba(0,0,0,0.6)', wordBreak: 'break-all' }}>{query.description != '' ? query.description : 'No description added for the query.'}</p>
                                        </div>
                                        <div className="viewQuery-attachments">
                                            <p style={{ fontSize: 14, fontWeight: 'bold' }}>Attachment</p>
                                            <div className="query-attachment-container">
                                                {
                                                    query.attachment_file_name_array != undefined &&
                                                        query.attachment_file_name_array.length > 0 ?
                                                        query.attachment_file_name_array.map(attachment => {
                                                            return (
                                                                <p className="image-attachment-box" onClick={() => this.viewQueryAttachment(query, attachment)}>
                                                                    {attachment.substring(attachment.lastIndexOf('.') + 1)}
                                                                </p>
                                                            );
                                                        })
                                                        :
                                                        <p className='text-muted' style={{ fontSize: 14 }}>No attachment added to service request.</p>
                                                }
                                            </div>
                                        </div>
                                        <div className='commentLink'>
                                            <div className={this.state.currentCommentTab == 'correspondence' ? 'link-active correspondenceComment' : "correspondenceComment"} onClick={() => this.setState({ currentCommentTab: 'correspondence' })}>
                                                Correspondence
                                            </div>
                                        </div>
                                        <div className="commentContainer">
                                            {
                                                this.state.currentCommentTab == 'correspondence' &&
                                                <>
                                                    <div className="correspondenceComment-container">
                                                        {
                                                            Object.keys(this.state.correspondenceComments).length > 0 ?
                                                                this.state.correspondenceSequence.map(commentId => {
                                                                    let comment = this.state.correspondenceComments[commentId];
                                                                    return (
                                                                        <>
                                                                            <div key={commentId} className="comment-details">
                                                                                <div className="added-by-details col-md-2" style={{ paddingLeft: 0 }}>
                                                                                    <p className="comment-added-by">{comment.name}</p>
                                                                                    <p className="comment-added-on">{comment.added_on}</p>
                                                                                </div>
                                                                                <div className="comment-text col-md-6" style={{ paddingRight: 0 }}>
                                                                                    <p className="comment-title">
                                                                                        {ReactHtmlParser(comment.comment)}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="comment-attachment">
                                                                                {
                                                                                    comment.attachment_array.length > 0 &&
                                                                                    comment.attachment_array.map(attachment => {
                                                                                        return (
                                                                                            <p className="image-white-box" title='Click to view attachment' onClick={() => this.viewAttachment(comment, attachment)}>
                                                                                                {attachment.substring(attachment.lastIndexOf('.') + 1)}
                                                                                            </p>
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })
                                                                :
                                                                <p className="text-muted" style={{ fontSize: 14 }}>No correspondence comments added.</p>
                                                        }
                                                        {
                                                            Object.keys(this.state.correspondenceComments).length > 0 &&
                                                            <div id="paginationContainer">
                                                                <Pagination
                                                                    activePage={this.state.pageIndex}
                                                                    itemsCountPerPage={this.state.limit}
                                                                    totalItemsCount={this.state.correspondenceCount}
                                                                    pageRangeDisplayed={3}
                                                                    onChange={(num) => this.updateCommentPaginationCount(num)}
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                    <div style={{ backgroundColor: '#F4F4F4' }} className="d-flex align-items-center justify-content-end">
                                                        {
                                                            query.current_status != 'closed' &&
                                                            <div className="comment-submit-buttons">
                                                                {
                                                                    this.state.markAsResolvedApiStarted &&
                                                                    <ButtonLoader />
                                                                }
                                                                <button className="btn primary-button submitComment mr-2" onClick={() => this.setState({ viewStatusConfirmModal: true })}>Mark As Resolved</button>
                                                            </div>
                                                        }
                                                        {
                                                            query.current_status == 'closed' && comparisonDate != "" &&
                                                            currentDate < comparisonDate &&
                                                            <div className="comment-submit-buttons">
                                                                {
                                                                    this.state.markAsResolvedApiStarted &&
                                                                    <ButtonLoader />
                                                                }
                                                                <button className="btn primary-button submitComment mr-2" onClick={() => this.setState({ viewReopenConfirmationModal: true })}>Re-open</button>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="addComment m-1">
                                                        {
                                                            this.state.commentResponseMessage.length > 0 &&
                                                            <div className="response-message">
                                                                <p className={this.state.commentResponseType == 'success' ? 'alert alert-success' : this.state.commentResponseType == 'warning' ? 'alert alert-warning' : this.state.commentResponseType == 'error' && 'alert alert-danger'}>
                                                                    {this.state.commentResponseMessage}
                                                                    <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.setState({ commentResponseType: '', commentResponseMessage: '' })} title="Click to close message" />
                                                                </p>
                                                            </div>
                                                        }
                                                        {/* <CKEditor
                                                            data={this.state.correspondenceComment}
                                                            config={{
                                                                toolbar_Basic: [['Bold', 'Italic'], ['Table']],

                                                                toolbar: [
                                                                    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'], items: ['Bold', 'Italic', 'Underline'] },
                                                                    { name: 'paragraph', groups: ['list'], items: ['BulletedList'] },
                                                                    { name: 'insert', items: ['Table'] },
                                                                ],
                                                            }}

                                                            onChange={(e) => this.getCorrespondenceComment(e)}
                                                        /> */}
                                                        <ReactQuill
                                                            value={this.state.correspondenceComment}
                                                            onChange={this.getCorrespondenceComment}

                                                            modules={QueryDetails.modules}
                                                            formats={QueryDetails.formats}
                                                            placeholder="Write something..."
                                                            style={editorStyle}
                                                        />
                                                        <div className="attachment-submit">
                                                            <div className="query-attachment">
                                                                <input id="correspondenceAttachment" onChange={(e) => this.getCorrespondenceAttachments(e)} type="file" style={{ display: 'none' }} multiple />
                                                                <button className="btn attach-comment-button" onClick={() => this.clickCorrespondenceAttachment()}>
                                                                    <FontAwesomeIcon icon={['fas', 'paperclip']} style={{ marginRight: 5 }} />
                                                                    Attach Files
                                                                </button>
                                                                <span style={{ marginLeft: 10, fontSize: 14 }}>
                                                                    {
                                                                        this.state.correspondenceAttachments.length > 0 &&
                                                                        this.state.correspondenceAttachments.map((file, fileIndex) => {
                                                                            return (
                                                                                <p className="query-file" style={{ marginTop: 10 }}>
                                                                                    <p className="image-box">
                                                                                        {file.name.substring(file.name.lastIndexOf('.') + 1)}
                                                                                    </p>
                                                                                    <p>
                                                                                        <p>
                                                                                            {file.name}
                                                                                            <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeCorrespondenceSelectedFile(fileIndex)} />
                                                                                        </p>
                                                                                        <p className="text-muted">{(file.size / 1000)} KB</p>
                                                                                    </p>
                                                                                </p>
                                                                            );
                                                                        })
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div className="comment-submit-buttons">
                                                                {
                                                                    this.state.addingCorrespondenceComment &&
                                                                    <ButtonLoader />
                                                                }
                                                                <button className="btn primary-button submitComment mr-2" onClick={() => this.validateCorrespondenceCommentDetails()} disabled={this.state.addingCorrespondenceComment}>Submit</button>
                                                                <button className="btn outline-button submitComment" onClick={() => this.cancelAddCorrespondenceComment()}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p style={{ marginTop: 10, fontSize: 14 }} className="text-danger">{this.state.correspondenceCommentWarning}</p>
                                                </>
                                            }
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO RETURN CONFIRMATION MODAL TO MARK THE QUERY AS RESOLVED
    returnResolveConfirmationModal = () => {
        return (
            <div className={this.state.viewStatusConfirmModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header modalHeader">
                            <div className="iconContainer" style={{ backgroundColor: '#0fa127' }}>
                                <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} size="lg" color='#FFFFFF' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Are You Sure ?</h3>
                        </div>
                        <div className="modal-body deleteModalBody">
                            <p className="note-text">
                                Are you sure you want to mark the query as <span style={{ fontWeight: 'bold' }}>Resolved</span>?
                            </p>
                        </div>

                        <div className="modal-footer">

                            <div id="addAssetButtonContainer" style={{ display: 'flex', gap: '10px' }}>
                                <button className="btn btn-success waves-effect" onClick={() => this.apiCallToMarkAsResolved()}>Yes</button>

                                <button className="btn btn-outline-secondary" onClick={() => this.setState({ viewStatusConfirmModal: false })}>No</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO RETURN CONFIRMATION MODAL TO MARK THE QUERY AS REOPENED
    returnReopenConfirmationModal = () => {
        return (
            <div className={this.state.viewReopenConfirmationModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header modalHeader">
                            <div className="iconContainer" style={{ backgroundColor: '#FF0000' }}>
                                <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} size="lg" color='#FFFFFF' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Are You Sure ?</h3>
                        </div>
                        <div className="modal-body deleteModalBody">
                            <p className="note-text">
                                Are you sure you want to <span style={{ fontWeight: 'bold' }}>Re-open</span> the query?
                            </p>
                        </div>

                        <div className="modal-footer">

                            <div id="addAssetButtonContainer">
                                <button className="btn delete-outline-button waves-effect" onClick={() => this.apiCallToReopenQuery()}>Yes</button>

                                <button className="btn delete-primary-button" onClick={() => this.setState({ viewReopenConfirmationModal: false })}>No</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    apiCallToGetQueriesLinkedToSprint = async (id, title, startDate, endDate) => {
        this.setState({
            // queryDetailsFetching: true,
            sprintLoader: true,
            activeInfo: true,

            selectedSprintId: id,
            selectedTitleInfo: title,
            selectedStartDate: startDate,
            selectedEndDate: endDate
        })
        let requestData = {
            "sprint_id": id,
        }
        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'HelpDeskGetQueriesLinkedToSprint',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetQueriesLinkedToSprint()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    sprintLoader: false,
                    individualSprintData: apiResult,
                })
            }
            else {
                this.setState({
                    sprintLoader: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting individual Module request details. Please try again later.'
                });
            }
        }
    }



    // METHOD TO RETURN VIEW Module Request 
    returnViewModule = () => {
        let sprint = this.state.sprintDetails;
        let moduleName = "Module Wise Version's";
        return (
            <div className={this.state.viewSprintModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog viewQuery-dialog">
                    <div className="modal-content viewQuery-content">
                        <div className='modal-header'>
                            <label className="moduleTitle mt-2" style={{ color: 'black' }}>{moduleName}</label>
                            {/* <FontAwesomeIcon icon={['fas', 'times']} style={{ fontWeight: 'normal', cursor: 'pointer', color: '#FFFFFF' }} size="lg" onClick={() => this.closeViewQuery()} /> */}
                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" style={{ marginRight: 10, cursor: 'pointer' }} onClick={() => this.closeViewQuery()} />
                        </div>
                        <div className="modal-body viewQuery-body col-md-12">
                            <div className='sprintSection'>
                                <div>
                                    <select
                                        type="text"
                                        className="form-control filterInput"
                                        // style={{borderColor: 'rgba(255,255,255,0)'}}
                                        value={this.state.selectedModuleId}
                                        onChange={(e) => { this.setState({ selectedModuleId: e.target.value, activeInfo: false }, () => { this.apiCallToGetIndividualModuleDetails() }) }}
                                    >
                                        <option value=''>Select Module</option>
                                        {
                                            Object.keys(this.state.subscriptionModuleList).length > 0 &&
                                            Object.values(this.state.subscriptionModuleList).map(module => {

                                                return (
                                                    <option key={module.moduleId} value={module.moduleId}>{module.module_name}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                                <div style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: 20 }}>
                                    <div class="dropdown selectDateDropdown ml-2 mr-2 mt-2 mb-2">
                                        {/* <label className = "filterLabelClassName" >Date</label> */}
                                        <p className='pointer dropDownLabel' data-toggle="dropdown" >
                                            <span className='mr-3' style={{ color: '#818181', fontSize: 12 }}>Select Date</span>
                                            <FontAwesomeIcon icon={['fas', 'calendar']} size='xs' style={{ cursor: 'pointer' }} />
                                        </p>
                                        <div class="dropdown-menu mt-4" aria-labelledby="dropdownMenuButton" style={{ position: 'absolute', left: '170px', height: 130 }}>
                                            <div className='p-2' style={{ height: '80px', width: '262px' }}>
                                                <div className="row">
                                                    <div className={"popoverTextTitle"}>From</div>
                                                    <div className={"popoverTextTitle"}>To</div>
                                                    <div ></div>
                                                    <div className={"popoverTextTitle"}>
                                                        <input
                                                            type="date"
                                                            placeholder="Enter Start date"
                                                            className="fom popoverInput w-100  form-control"
                                                            value={this.state.FilterStartDate}
                                                            max={this.state.FilterEndDate}
                                                            onChange={(e) => this.setState({ FilterStartDate: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className={"popoverTextTitle"}>
                                                        <input
                                                            type="date"
                                                            min={this.state.FilterStartDate}
                                                            placeholder="Enter End date" className="form-control popoverInput w-100"
                                                            value={this.state.FilterEndDate}
                                                            onChange={(e) => this.setState({ FilterEndDate: e.target.value })}
                                                        />
                                                    </div>
                                                    <button className="btn btn-primary" style={{ width: '100%' }} onClick={() => this.validateDate()}>Apply</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ margin: 5, justifyContent: 'center', alignItems: 'center' }}>
                                <label className='desc1'> All requests are handled according to the agile methodology. Request goes under various survey’s and according to priority it is distributed among the versions. Firstly, the request will be studied, reviewed and after several approval processes from the product research team, it will be assigned to the nearest version as per the availability.</label>
                            </div>
                            <div className='content'>
                                <div className='left' >
                                    {
                                        this.state.moduleLoader ? <Spinner /> :
                                            Object.keys(this.state.sprintDetails).length > 0 ?
                                                Object.values(this.state.sprintDetails).map(sprint => {
                                                    return (
                                                        <div className='card mt-3' style={{ borderRadius: '0.6rem', cursor: 'pointer', borderLeft: sprint.sprintId === this.state.selectedSprintId ? '6px solid #0465AC' : 'none' }} onClick={() => this.apiCallToGetQueriesLinkedToSprint(sprint.sprintId, sprint.title, sprint.startDate, sprint.endDate)}>
                                                            <label className='version mt-2 ml-2' style={{ cursor: 'pointer', textTransform: 'capitalize' }}>{sprint.title}</label>
                                                            <label className='date ml-2 mr-2' style={{ cursor: 'pointer' }}>{sprint.startDate} - {sprint.endDate}</label>
                                                            <div className='innerCard' style={{
                                                                backgroundColor: sprint.status === 'ongoing' ? '#EEE3FF' : sprint.status === 'proposed' ? '#D3EAFF' : '#B2ECC6'
                                                            }}>
                                                                <label className='status pl-2 pr-2 pt-1' style={{
                                                                    cursor: 'pointer',
                                                                    color: sprint.status === 'ongoing' ? '#9C6AEB' : sprint.status === 'proposed' ? '#3576B2' : '#358851'
                                                                }}
                                                                >
                                                                    {
                                                                        sprint.status == 'ongoing' ? 'Ongoing Version'
                                                                            :
                                                                            sprint.status == 'proposed' ? 'Proposed Version - Open for new requests'
                                                                                :
                                                                                'Completed Version Successfully.'
                                                                    }
                                                                </label>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                                :
                                                <div className='card mt-3' style={{ borderRadius: '0.6rem' }}>
                                                    <label className='version mt-2 ml-2 pl-1 pr-2'>Versions not available.</label>
                                                </div>
                                    }
                                </div>
                                {
                                    this.state.activeInfo
                                        ?
                                        <div className='right ml-4'>
                                            <div className='progressCard' style={{ borderRadius: '0.6rem', backgroundColor: '#E6F4FF', borderLeft: '6px solid #0465AC' }}>
                                                <div className="icon1 ml-2 mt-2">
                                                    <FontAwesomeIcon icon={['fas', 'calendar']} size="0.5x" color="#5D5FEF" />
                                                    {/* <FontAwesomeIcon icon="fa-solid fa-rectangle-vertical-history" size="0.5x" color="#5D5FEF"/> */}
                                                </div>
                                                <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                                                    <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                                                        <label className='version mt-2 ml-2'>{this.state.selectedTitleInfo}</label>
                                                        <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                                                            <label className='date ml-2 mr-2'>{this.state.selectedStartDate} - {this.state.selectedEndDate}</label>
                                                            <div className='ml-1 mb-1 shortDiv'>
                                                                <label className='date ml-2 mr-2 mt-1 shortDivText'>Proposed Version - Open for new requests</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <label className='note1 mt-2'>Currently, following queries are in progress for this version.</label>
                                            <br />
                                            {
                                                this.state.sprintLoader ? <Spinner /> :
                                                    Object.keys(this.state.individualSprintData).length > 0
                                                        ?
                                                        Object.values(this.state.individualSprintData).map(query => {
                                                            return (
                                                                <div className='progressCard mt-3' style={{ borderRadius: '0.6rem', backgroundColor: '#F1F5F8' }}>
                                                                    <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                                                                        <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                                                                            <label className='version mt-2 ml-2'>{query.queryId}</label>
                                                                            <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                                                                                <label className='date ml-2 mr-2'>- </label>
                                                                                <div className='ml-1 mb-1'>
                                                                                    <label className='date ml-2 mr-2 mt-1 '>{query.description}</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        <div className='progressCard mt-3' style={{ borderRadius: '0.6rem', backgroundColor: '#F1F5F8' }}>
                                                            <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                                                                <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                                                                    <label className='version mt-2 ml-2 align-item-center'>Service request's are not available.</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                            }
                                        </div>
                                        :
                                        <div className='defaultCard ml-4 mt-3' >
                                            <label className='version mt-3 mb-2 ml-2 '>Please select version to get service request's.</label>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO GET PREVIOUS Service Request
    getPreviousQuery = () => {
        this.setState({
            currentQueryIndex: this.state.currentQueryIndex - 1,
            currentQueryId: this.state.querySequence[this.state.currentQueryIndex - 1],
            queryInstituteId: this.state.queryList[this.state.querySequence[this.state.currentQueryIndex - 1]].iid
        }, () => {
            this.apiCallToGetIndividualQueryDetails();
        });
    }

    // METHOD TO GET NEXT Service Request
    getNextQuery = () => {
        this.setState({
            currentQueryIndex: this.state.currentQueryIndex + 1,
            currentQueryId: this.state.querySequence[this.state.currentQueryIndex + 1],
            queryInstituteId: this.state.queryList[this.state.querySequence[this.state.currentQueryIndex + 1]].iid
        }, () => {
            this.apiCallToGetIndividualQueryDetails();
        });
    }

    // METHOD TO GET CORRESPONDENCE COMMENT
    getCorrespondenceComment = (e) => {
        let comment = this.stripHtml(e);
        this.setState({
            correspondenceComment: e
        });
    }

    // METHOD TO CLICK CORRESPONDENCE COMMENT ATTACHMENT INPUT
    clickCorrespondenceAttachment = () => {
        document.getElementById('correspondenceAttachment').click();
    }

    // METHOD TO GET CORRESPONDENCE COMMENT ATTACHMENT FILES
    getCorrespondenceAttachments = (e) => {
        let files = e.target.files;
        this.setState({
            correspondenceAttachments: Object.values(e.target.files)
        });

        if (files.length > 0) {
            Object.values(files).map(file => {
                let allowedExtension = /(\.exe|\.php|\.js|\.cpp|\.c|\.java)$/i;
                if (allowedExtension.exec(file.name)) {
                    this.setState({
                        correspondenceAttachmentTypeWarning: '.exe, .php, .js, .cpp, .c, .java. extension files are not allowed.'
                    });
                } else {
                    if ((file.size / 1048576.0) > 50) {
                        this.setState({
                            correspondenceAttachmentSizeWarning: 'Please select file less than 50MB.'
                        });
                    } else {
                        this.setState({
                            correspondenceAttachmentSizeWarning: '',
                        });
                    }

                    this.setState({
                        correspondenceAttachmentTypeWarning: ''
                    });
                }
            });
        }
    }

    handleCloseServiceRequestModal = () => {
        this.setState({
            addQuery: false
        });
    }

    // METHOD TO REMOVE CORRESPONDENCE COMMENT SELECTED FILE
    removeCorrespondenceSelectedFile = (fileIndex) => {
        let correspondenceAttachments = this.state.correspondenceAttachments;
        correspondenceAttachments.splice(fileIndex, 1);
        this.setState({
            correspondenceAttachments
        });
    }

    // METHOD TO VALIDATE CORRESPONDENCE COMMENT DETAILS
    validateCorrespondenceCommentDetails = () => {
        let validData = true;

        if (this.stripHtml(this.state.correspondenceComment).length < 1) {
            this.setState({
                correspondenceCommentWarning: 'Comment cannot be empty.'
            });
            validData = false;
        }

        if (validData) {
            // METHOD CALLED TO ADD CORRESPONDENCE COMMENT
            this.apiCallToAddCorrespondenceComment();
        }
    }

    // API CALL METHOD TO ADD CORRESPONDENCE COMMENT
    apiCallToAddCorrespondenceComment = async () => {
        this.setState({
            addingCorrespondenceComment: true
        });

        let formData = new FormData();

        formData.append('PostCommentToClientCorrespondenceFromHelpDesk', true);
        formData.append('data', Base64.encode(JSON.stringify({
            "role": "Instructor",
            "useruid": config.faculty_id,
            "comment": this.state.correspondenceComment,
            "queryId": this.state.currentQueryId,
            "iid": config.institute_id
        })));

        if (this.state.correspondenceAttachments.length > 0) {
            this.state.correspondenceAttachments.map(attachment => {
                formData.append('Correspondence_attachments[]', attachment);
            });
        } else {
            formData.append('Correspondence_attachments[]', []);
        }

        let parameterData = JSON.stringify({
            source: 'app',
            uid: config.faculty_id,
            email: config.emailId,
            role: 'instructor'
        });

        formData.append('tokenInputParameter', Base64.encode(parameterData));

        const headers = {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Authorization": "Basic " + config.user_token
        };

        await axios.post(
            config.RootUrl + '/api/helpDesk/employee/Queries.php',
            formData,
            {
                headers: headers,
            }
        ).then(response => {
            if (response.data.success) {
                response = response.data;
                if (response.status == 'success') {
                    let correspondenceComments = this.state.correspondenceComments;
                    let correspondenceSequence = this.state.correspondenceSequence;
                    let correspondenceCount = this.state.correspondenceCount;

                    if (correspondenceCount < this.state.commentLimit) {
                        correspondenceCount = correspondenceCount + 1;
                        correspondenceSequence.push(response.UID);
                        if (correspondenceComments[response.UID] == undefined) {
                            correspondenceComments[response.UID] = {};
                        }

                        correspondenceComments[response.UID]['uniqueid'] = response.UID;
                        correspondenceComments[response.UID]['name'] = config.instructorInfo.FirstName + ' ' + config.instructorInfo.LastName;
                        correspondenceComments[response.UID]['queryid'] = this.state.currentQueryId;
                        correspondenceComments[response.UID]['comment'] = this.state.correspondenceComment;
                        correspondenceComments[response.UID]['added_on'] = response.added_on;
                        correspondenceComments[response.UID]['added_by'] = config.faculty_id;
                        correspondenceComments[response.UID]['lastUpdatedOn'] = '';
                        correspondenceComments[response.UID]['role'] = 'Instructor';
                        correspondenceComments[response.UID]['attachment'] = '';
                        correspondenceComments[response.UID]['attachment_file_path'] = response.attachment_file_path;
                        correspondenceComments[response.UID]['attachment_array'] = response.attachmentNameArray;
                    }

                    this.cancelAddCorrespondenceComment();

                    this.setState({
                        addingCorrespondenceComment: false,
                        correspondenceCommentResponseMessage: response.message,
                        correspondenceCommentResponseType: 'success',
                        correspondenceCount,
                        correspondenceComments,
                        correspondenceSequence
                    });
                } else {
                    this.setState({
                        addingCorrespondenceComment: false,
                        correspondenceCommentResponseMessage: response.message,
                        correspondenceCommentResponseType: 'warning',
                    });
                }
            } else {
                this.setState({
                    addingCorrespondenceComment: false,
                    correspondenceCommentResponseMessage: 'Something went wrong while adding correspondence comment. Please try again later.',
                    correspondenceCommentResponseType: 'error',
                });
            }
        });
    }

    // API CALL METHOD TO MARK THE QUERY AS RESOLVED
    apiCallToMarkAsResolved = async () => {
        this.setState({
            markAsResolvedApiStarted: true,
            viewStatusConfirmModal: false
        });

        let requestData = {
            "query_id": this.state.currentQueryId,
            "iid": config.institute_id,
            "faculty_id": config.faculty_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'markQueryAsResolved',
            requestData,
            '/api/helpDesk/employee/Queries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToMarkAsResolved()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                this.apiCallToGetIndividualQueryDetails();

                if (jsonResponse.APIResult.status == "success") {
                    this.setState({
                        markAsResolvedApiStarted: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: jsonResponse.APIResult.message,
                    });
                }
                else {
                    this.setState({
                        markAsResolvedApiStarted: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: jsonResponse.APIResult.message,
                    });
                }

            } else {
                this.setState({
                    markAsResolvedApiStarted: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating the query status. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO REOPEN THE QUERY
    apiCallToReopenQuery = async () => {
        this.setState({
            markAsResolvedApiStarted: true,
            viewReopenConfirmationModal: false
        });

        let requestData = {
            "query_id": this.state.currentQueryId,
            "iid": config.institute_id,
            "faculty_id": config.faculty_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'reOpenClientQuery',
            requestData,
            '/api/helpDesk/employee/Queries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToReopenQuery()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                this.apiCallToGetIndividualQueryDetails();

                if (jsonResponse.APIResult.status == "success") {
                    this.setState({
                        markAsResolvedApiStarted: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: jsonResponse.APIResult.message,
                    });
                }
                else {
                    this.setState({
                        markAsResolvedApiStarted: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: jsonResponse.APIResult.message,
                    });
                }

            } else {
                this.setState({
                    markAsResolvedApiStarted: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating the query status. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE ADD CORRESPONDENCE COMMENT
    cancelAddCorrespondenceComment = () => {
        this.setState({
            correspondenceComment: '',
            correspondenceCommentWarning: '',
            correspondenceAttachments: [],
            correspondenceAttachmentSizeWarning: '',
            correspondenceAttachmentTypeWarning: '',
            addingCorrespondenceComment: false
        });
    }

    // METHOD TO GET MAIL BODY LENGTH
    stripHtml = (data) => {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = data;
        return tmp.textContent || tmp.innerText || "";
    }

    // METHOD TO VIEW ATTACHMENT
    viewAttachment = (comment, attachment) => {
        this.setState({
            viewAttachment: true,
            attachmentPath: comment.attachment_file_path,
            attachmentFile: attachment,
            attachmentFileExtension: attachment.substring(attachment.lastIndexOf('.') + 1)
        });
    }

    // METHOD TO RETURN VIEW ATTACHMENT
    returnViewAttachment = () => {
        let imageExtensions = ['png', 'jpg', 'jpeg', 'svg'];
        return (
            <div className={this.state.viewAttachment ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Attachment</h3>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeViewAttachment()} />
                        </div>
                        <div className="modal-body viewAttachment-body">
                            {
                                imageExtensions.includes(this.state.attachmentFileExtension) ?
                                    <div>
                                        <img src={this.state.attachmentPath + '/' + this.state.attachmentFile} width='100%' height='400px' />
                                    </div>
                                    :
                                    <iframe src={this.state.attachmentPath + '/' + this.state.attachmentFile} width="100%" height="400px" />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CLOSE VIEW ATTACHMENT
    closeViewAttachment = () => {
        this.setState({
            viewAttachment: false
        });
    }

    // METHOD TO CLOSE VIEW Service Request
    closeViewQuery = () => {
        this.setState({
            viewQuery: false,
            viewSprintModal: false,
            activeInfo: false,
            currentQueryIndex: '',
            currentQueryId: '',
            queryDetails: '',
            sprintDetails: ''
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    // METHOD TO SELECT Service Request Type
    setStatus = (e) => {
        this.setState({
            status: e.target.value,
            pageIndex: 1,
            offset: 0
        }, () => {
            this.apiCallToGetQueries();
        });
    }

    formatDate = (date) => {
        // Check if the date parameter is a valid date string
        if (!date || isNaN(Date.parse(date))) {
            return "Invalid date";
        }

        // Current date
        let currentDate = new Date();
        // Target date
        let targetDate = new Date(date);

        // Calculate the difference in milliseconds
        let differenceInMs = targetDate - currentDate;
        // Convert milliseconds to days and round down to the nearest whole number
        let differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));

        // Output the difference
        if (differenceInDays > 7) {
            // Convert days to weeks, months, or years
            let weeks = Math.floor(differenceInDays / 7);
            let months = Math.floor(differenceInDays / 30);
            let years = Math.floor(differenceInDays / 365);


            // Choose the appropriate unit based on the duration
            let output = (weeks >= 4 && weeks < 52) ? `${months == 1 ? "1 month" : months} ${months == 1 ? "to go" : "months to go"}` : weeks >= 52 ? `${years == 1 ? "1 year" : years} ${years == 1 ? "to go" : "years to go"}` : `${weeks == 1 ? "1 week" : weeks} ${weeks == 1 ? "to go" : "weeks to go"}`;
            return output;
        } else {
            return `1 week to go`;
            // return `${differenceInDays} days to go`;
        }
    }

    apiCallToGetLiveUpdates = async () => {
        this.setState({ loadingUpdates: true });
        try {
            const jsonResponse = await HelpdeskApiCall.makeApiCall(
                'helpDeskGetDevelopmentSprints',
                { "iid": config.institute_id, 'filter_status': 'proposed' },
                '/api/helpDesk/helpDeskSupport.php'
            );

            if (jsonResponse.expired) {
                setTimeout(this.apiCallToGetLiveUpdates, 1000);
                return;
            }

            if (jsonResponse.success) {
                const { data, sprintIds } = jsonResponse?.APIResult;
                let carouselContent = [];
                if (sprintIds?.length > 0 && Object?.keys(data)?.length > 0) {
                    let completedSprints = [];
                    let upcomingSprints = [];

                    Object.keys(data).forEach(key => {
                        Object.values(data[key]).forEach(sprintObj => {
                            if (sprintIds.includes(sprintObj?.sprintId?.toString())) {
                                let status = (sprintObj?.status?.toLowerCase() === "completed" || sprintObj?.status?.toLowerCase() === "delivered") ? "DELIVERED" : "UPCOMING";
                                let sprintData = {
                                    moduleName: sprintObj?.moduleName,
                                    releaseNumber: sprintObj?.sprintId,
                                    numOfFeaturesProvided: sprintObj?.totalQueries,
                                    deadlineDate: sprintObj?.rawEndDate,
                                    status: status
                                };
                                if (status === "DELIVERED") {
                                    completedSprints.push(sprintData);
                                } else {
                                    upcomingSprints.push(sprintData);
                                }
                            }
                        });
                    });

                    // Interleave completed and upcoming sprints
                    carouselContent = [];
                    let maxLength = Math.max(completedSprints.length, upcomingSprints.length);
                    for (let i = 0; i < maxLength; i++) {
                        if (i < completedSprints.length) {
                            carouselContent.push(completedSprints[i]);
                        }
                        if (i < upcomingSprints.length) {
                            carouselContent.push(upcomingSprints[i]);
                        }
                    }
                }
                this.setState({ releaseUpdateList: data, carouselContent });
            } else {
                this.setState({ releaseUpdateList: {} });
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.setState({ loadingUpdates: false });
        }
    }

    liveUpdateView = () => {
        const { loadingUpdates, releaseUpdateList, carouselContent } = this.state;
        return (
            <div className="container-fluid p-0 mb-4">
                <div className="d-flex flex-column col-md-12 p-0 justify-content-center" style={{ backgroundColor: '#FFFFFF' }}>
                    <Carousel className='w-100' showStatus={false} showThumbs={false} showArrows={false} showIndicators={false} autoPlay={true} infiniteLoop={true} interval={3000} style={{ backgroundColor: '#FFFFFF' }} >

                        {
                            carouselContent?.map((item, i) => {
                                const isUpcoming = item.status === 'upcoming' || item.status === 'COMING SOON' || item.status === 'UPCOMING';
                                const text = isUpcoming ? 'COMING SOON' : 'DELIVERED';
                                return (
                                    // <div key={item.releaseNumber} className='col-md-12 carouselItem p-4 m-2 w-100' style={{ backgroundImage: isUpcoming ? 'linear-gradient(90deg, #0469FF 0%, #023F99 100%)' : 'linear-gradient(90deg, #00BFBD 0%, #008A86 100%)' }}>
                                    <div className="col-md-12 row justify-content-between align-items-center carouselItem p-4 " style={{ width: '99%', alignSelf: 'center', height: '25vh', backgroundImage: isUpcoming ? 'linear-gradient(90deg, #0469FF 0%, #023F99 100%)' : 'linear-gradient(90deg, #00BFBD 0%, #008A86 100%)' }}>
                                        <div className="d-flex flex-column m-0" style={{ width: '30%' }}>
                                            <label className='moduleName pb-0 m-0'>{item.moduleName}</label>
                                            <label className='releaseNum'>Release Number: {item.releaseNumber}</label>
                                        </div>
                                        <div className="detailsView">
                                            {isUpcoming ? (
                                                <div className="row justify-content-center align-items-center">
                                                    <img src={timeIC} alt="time needed" style={{ width: 30, height: 30 }} />
                                                    <div className="d-flex flex-column ml-3">
                                                        <label className='timeText pb-0 m-0'>{this.formatDate(item.deadlineDate)}</label>
                                                        <label className='releaseNum pt-0 m-0'>Probable Completion</label>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="row justify-content-center align-items-center responsive-div" style={{ width: '25%' }}>
                                                    <label className='releaseNum pt-0 m-0'>{`  `}</label>
                                                </div>
                                            )}

                                            {isUpcoming && (<div className="bar pr-2"></div>)}

                                            <div className="row justify-content-center align-items-center ">
                                                <img src={magicIC} alt="time needed" style={{ width: 30, height: 30 }} />
                                                <div className="d-flex flex-column ml-3">
                                                    <label className='timeText pb-0 m-0'>{item.numOfFeaturesProvided}</label>
                                                    <label className='releaseNum pt-0 m-0'>Features Provided</label>
                                                </div>
                                            </div>

                                            <div className="bar pl-2"></div>

                                            <span className='statusText w-25'>
                                                <Typewriter
                                                    words={[text]}
                                                    loop={0}
                                                    cursor
                                                    cursorStyle=''
                                                    typeSpeed={70}
                                                    deleteSpeed={50}
                                                    delaySpeed={1000}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                    // </div>
                                )
                            })
                        }
                    </Carousel>

                    {
                        Object?.keys(releaseUpdateList)?.length > 0 && (<label className='headerText_HelpDesk text-left mt-3 mb-3'>Module wise Release Updates</label>)
                    }

                    {
                        loadingUpdates
                            ?
                            <div className="d-flex justify-content-center align-items-center w-100">
                                <Spinner />
                            </div>
                            : Object?.keys(releaseUpdateList)?.length > 0
                                ? (
                                    Object?.keys(releaseUpdateList)?.map(key => {
                                        const modulesObject = releaseUpdateList[key];
                                        const moduleData = Object?.values(modulesObject);
                                        const moduleIcon = moduleData[0]?.moduleIcon;
                                        return (
                                            <div className="table-content mb-1">
                                                <div className="table-title row m-0 p-2 pl-3">
                                                    {
                                                        (moduleIcon === "" || moduleIcon === "clipboard-question")
                                                            ?
                                                            <img src={defaultIc} style={{ width: 12, height: 12 }} />
                                                            :
                                                            <FontAwesomeIcon icon={['fas', moduleIcon]} size="md" color="#0025BA" style={{ cursor: "pointer" }} />
                                                    }
                                                    <label className='titleText_HelpDesk text-left m-0 ml-3'>{key}</label>
                                                </div>
                                                <div className="table-responsive table-container">
                                                    <table className="table">
                                                        <thead className='table-header m-0'>
                                                            <tr>
                                                                <th scope="col">Release No.</th>
                                                                <th scope="col">Number of Changes Planned</th>
                                                                <th scope="col">Release Document</th>
                                                                <th scope="col">Status</th>
                                                                <th ></th>
                                                                <th scope="col">Projected Completion</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                moduleData?.length > 0
                                                                    ? (
                                                                        moduleData?.map(releaseObject => {
                                                                            const releaseURL = `https://vmedulife-dev.s3.ap-south-1.amazonaws.com/pmtool/release/${releaseObject?.sprintId}`;
                                                                            // const disableView = releaseObject?.sprint_attachment_path == "" || releaseObject?.sprint_attachment_path == releaseURL;
                                                                            const disableView = !releaseObject?.sprint_attachment_name || releaseObject?.sprint_attachment_name == "";

                                                                            return (
                                                                                <tr className='contentText_HelpDesk'>
                                                                                    <td scope="row">{releaseObject?.sprintId}</td>
                                                                                    <td >{releaseObject?.totalQueries}</td>
                                                                                    <td >
                                                                                        <span
                                                                                            style={{ color: disableView ? '#959698' : '#2F80ED', cursor: disableView ? 'not-allowed' : 'pointer' }}
                                                                                            onClick={() => {
                                                                                                if (!disableView) {
                                                                                                    this.setState({ selectedSprintObj: releaseObject }, () => this.setState({ showSprintAttachment: true }));
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            View
                                                                                        </span>
                                                                                    </td>
                                                                                    <td >
                                                                                        <span className='p-1 pl-3 pr-3 ' style={{
                                                                                            backgroundColor: releaseObject?.status === "completed" ? "#E5FCDD" : "#FFF3D8",
                                                                                            color: releaseObject?.status === "completed" ? "#13A652" : "#F09400",
                                                                                            borderRadius: 5
                                                                                        }}>
                                                                                            {releaseObject?.status === "completed" ? "Delivered" : "Upcoming"}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td className='' style={{ maxWidth: 30, padding: 0 }}>
                                                                                        {
                                                                                            releaseObject?.status !== "completed" && (
                                                                                                <span className=''>
                                                                                                    <img className='image-fluid' src={rightArrowGif} style={{ width: '100%', transform: 'rotate(270deg)' }} />
                                                                                                </span>
                                                                                            )
                                                                                        }
                                                                                    </td>
                                                                                    <td >
                                                                                        <div className='row' style={{ backgroundColor: '' }}>
                                                                                            {
                                                                                                releaseObject?.status === "completed" ?
                                                                                                    <span className=''>{`-`}</span>
                                                                                                    :
                                                                                                    this.formatDate(releaseObject?.rawEndDate)
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    ) : (
                                                                        <tr className='mt-2 contentText_HelpDesk p-0   '>
                                                                            <td colSpan={6}>
                                                                                <label className='headerText_HelpDesk text-left'>No release planned for {key} module.</label>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <div className="def-title row m-0 p-2 pl-3 mt-3" >
                                        <label className='headerText_HelpDesk text-center m-0'>No release planned for any module.</label>
                                    </div>
                                )

                    }
                </div>
            </div>
        )
    }

    renderViewSprintModal = () => {
        const { showSprintAttachment, selectedSprintObj } = this.state;
        const fileName = selectedSprintObj?.sprint_attachment_name || "";
        const extension = fileName.split('.').pop();
        const releaseURL = `${selectedSprintObj?.sprint_attachment_path}/${selectedSprintObj?.sprint_attachment_name}`;

        return (
            <div className={showSprintAttachment ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-xl ">
                    <div className="modal-content viewSprintModal">
                        <div className="modal-body p-0 body-container">
                            <div className="p-2 pl-4">

                                <div className="row justify-content-between align-items-center pr-4 mt-3 w-100" >
                                    <div className=' row '>
                                        <div className="row pr-4" style={{ borderRight: '1px solid #FFFFFF', }}>
                                            <label className='releaseText text-center m-0 p-0' style={{ fontSize: 14 }}>Release No.</label>
                                            <label className='timeText text-center m-0 p-0 pl-2' style={{ fontSize: 18 }}>{selectedSprintObj?.sprintId}</label>
                                        </div>
                                        <label className='timeText text-center m-0 p-0 pl-2' style={{ fontSize: 18 }}>{selectedSprintObj?.moduleName}</label>
                                    </div>
                                    <div className='' onClick={() => this.setState({ showSprintAttachment: false })}>
                                        <FontAwesomeIcon icon={['fas', `times`]} color="#FFFFFF" style={{ cursor: 'pointer', fontSize: '16px' }} />
                                    </div>
                                </div>
                                <div className="noteView row mt-3 mb-4 mr-3" >
                                    <img src={dotPng} className='ml-3' alt="" style={{ width: 20, height: 20 }} />
                                    <label className='releaseText text-center m-0 p-1 pl-1 pr-3' style={{ fontSize: 12, textTransform: 'none' }}>The total number of service requests may seem less, because we are providing multiple features together.</label>
                                </div>
                            </div>

                            <div className="attachmentViewSprint">
                                <div className="m-2" style={{ height: '70vh' }}>
                                    {
                                        extension !== "pdf" ?
                                            // <div>
                                            <img src={releaseURL} style={{ width: '100%', height: '90%', resize: 'contain', alignSelf: 'center' }} />
                                            // </div>
                                            :
                                            <iframe src={releaseURL} style={{ width: "100%", height: "90%", border: "none", }} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    openLiveUpdatesView = () => {
        this.setState({ showLiveUpdateView: true });
    }

    closeLiveUpdatesView = () => {
        this.setState({ showLiveUpdateView: false });
    }

    // API CALL METHOD TO GET ONBOARDING STEP LIST
    apiCallToGetAssignedActivityOrModule = async () => {
        this.setState({ onboardingStepFetching: true });
        let requestData = {
            iid: config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getClientAssignedActivityOrModule',
            requestData,
            '/api/projectManagement/client/onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(this.apiCallToGetAssignedActivityOrModule, 1000);
        } else {
            if (jsonResponse.success) {
                const { data, modulesObject, completedVisits, subscriptionType, totalVisits, clientSubscribedModuleIds, sequenceIdArray } = jsonResponse.APIResult;
                const { staticPhaseDetails } = this.state;

                Object.values(data).forEach(step => { step.removingStep = false; });


                const tempPhaseDetails = Object.values(data => ({
                    [data.module_id_or_activity_id]: {
                        moduleId: data.module_id_or_activity_id,
                        phase: data.phase
                    }
                }));

                const phaseDetails = Object.fromEntries(Object.entries(staticPhaseDetails).map(([moduleId, phaseDetail]) => {
                    // Check if moduleId exists in tempPhaseDetails
                    const tempPhaseDetail = tempPhaseDetails.find(temp => temp[moduleId]);
                    // Use tempPhaseDetail if found, otherwise use staticPhaseDetail
                    return [moduleId, tempPhaseDetail ? tempPhaseDetail[moduleId] : phaseDetail];
                }));

                this.setState({
                    onboardingStepFetching: false,
                    phaseDetails,
                    updatedModuleDetails: modulesObject,
                    completedVisits,
                    subscriptionType,
                    totalVisits,
                    clientSubscribedModuleIds,
                    sequenceIdArray,
                });
            } else {
                this.setState({
                    onboardingStepFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting onboarding step list. Please try again later.'
                });
            }
        }
    }

    apiCallToGetModuleList = async () => {
        this.setState({
            modulesFetching: true
        })

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMInstituteModuleList',
            {},
            '/api/projectManagement/settings/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    moduleList: apiResult,
                    modulesFetching: false,
                    filteredModuleId: Object?.keys(apiResult)[0]
                }, () => this?.apiCallToGetHelpDeskModuleLSubmoduleListWithPoints());
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
            }
        }
    }

    apiCallToGetHelpDeskModuleLSubmoduleListWithPoints = async () => {
        const { filteredModuleId } = this.state;

        this.setState({ fetchingModuleDetails: true });

        try {
            const jsonResponse = await HelpdeskApiCall.makeApiCall(
                'GetHelpDeskModuleLSubmoduleListWithPoints',
                { iid: config.institute_id, filter_module: filteredModuleId },
                '/api/helpDesk/employee/moduleInformation.php'
            );

            if (jsonResponse.expired) {
                setTimeout(this.apiCallToGetHelpDeskModuleLSubmoduleListWithPoints, 1000);
            } else if (jsonResponse.success) {
                const { data } = jsonResponse.APIResult;
                this.setState({ fetchingModuleDetails: false, moduleDetails: data[filteredModuleId], successModal: false });
            } else {
                throw new Error('Failed to fetch module details');
            }
        } catch (error) {
            console.error('Error fetching module details:', error);
            this.setState({
                fetchingModuleDetails: false,
                moduleDetails: {},
                successModal: true,
                successModalType: 'error',
                successMessage: 'Something went wrong while getting client response list. Please try again later.'
            });
        }
    }

    handleSearch = () => {
        const { phaseDetails, searchKey, moduleList, filteredPhase } = this.state;
        this.setState({ modulesFetching: true });

        if (searchKey !== "" && filteredPhase !== "") {
            const tempModuleIds = Object.values(phaseDetails).filter(item => item.phase === filteredPhase).map(item => item.moduleId);

            // Filter moduleList based on tempModuleIds
            const updatedModuleListForPhase = Object.keys(moduleList).filter(id => tempModuleIds.includes(id)).reduce((acc, id) => {
                acc[id] = moduleList[id];
                return acc;
            }, {});

            const updatedModuleList = Object.values(updatedModuleListForPhase).reduce((acc, moduleObj) => {
                // Check if module_name contains the searchKey (case-insensitive)
                if (moduleObj.module_name.toLowerCase().includes(searchKey.toLowerCase())) {
                    acc[moduleObj?.unique_id] = moduleObj;
                }
                return acc;
            }, {});

            // Update state with the filtered module list
            this.setState({ updatedModuleList, modulesFetching: false });
        } else {
            if (searchKey !== "") {
                const updatedModuleList = Object.values(moduleList).reduce((acc, moduleObj) => {
                    // Check if module_name contains the searchKey (case-insensitive)
                    if (moduleObj.module_name.toLowerCase().includes(searchKey.toLowerCase())) {
                        acc[moduleObj?.unique_id] = moduleObj;
                    }
                    return acc;
                }, {});
                // Update state with the filtered module list
                this.setState({ updatedModuleList, modulesFetching: false });
            } else {
                // If searchKey is empty, set modulesFetching to false without updating the module list
                this.setState({ modulesFetching: false });
            }

            if (filteredPhase !== "") {
                // Extract module IDs that match the filtered phase
                const tempModuleIds = Object.values(phaseDetails)
                    .filter(item => item.phase === filteredPhase)
                    .map(item => item.moduleId);

                // Filter moduleList based on tempModuleIds
                const updatedModuleList = Object.keys(moduleList)
                    .filter(id => tempModuleIds.includes(id))
                    .reduce((acc, id) => {
                        acc[id] = moduleList[id];
                        return acc;
                    }, {});

                // Update state with the filtered module list
                this.setState({ updatedModuleList, modulesFetching: false });
            } else {
                this.setState({ modulesFetching: false });
            }
        }
    };

    // METHOD TO RETURN SELECT MODULES MODAL
    returnSelectModules = () => {
        const { phaseDetails, clientSubscribedModuleIds, moduleDetails, selectModules, moduleList, searchKey, filteredModuleId, updatedModuleList, modulesFetching, filteredPhase, updatedModuleDetails, filteredModuleName } = this.state;
        const { subModules, subModuleSequenceIdArray, font_awesome_icon, module_name } = moduleDetails || {};
        const clientSubscribedModulesCount = Object.keys(clientSubscribedModuleIds)?.length || 0;
        const totalModulesCount = Object.keys(moduleList)?.length || 0;

        let totalSelectedModuleIds = 0;
        let totalModuleIds = 0;

        if (moduleDetails) {
            totalModuleIds = subModules && Object.values(subModules)?.reduce((totalIds, item) => {
                return totalIds + (item.demoPointSequence ? item.demoPointSequence.length : 0);
            }, 0) + (subModuleSequenceIdArray?.length || 0);
        }

        const mappingList = (searchKey === "" && filteredPhase === "") ? moduleList : updatedModuleList;

        if (updatedModuleDetails[filteredModuleId]) {
            totalSelectedModuleIds = Object.values(updatedModuleDetails[filteredModuleId]).reduce((total, item) => {
                if (Array.isArray(item) && typeof item !== 'boolean' && typeof item !== 'string') {
                    return total + item.length;
                }
                return total;
            }, 0) + (Object.keys(updatedModuleDetails[filteredModuleId])?.length);
        }

        if (mappingList) {
            return (
                <div className={selectModules ? "modal fade show" : "modal fade"} id="modalContainer">
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "80%", borderRadius: 10, height: '90vh' }}>
                        <div className="modal-content" >
                            <div className="w-100 modal-header d-flex flex-column">
                                <div className="w-100 row justify-content-between align-items-center">
                                    <label className="modalHeaderTitle pl-2">Subscribed Modules</label>
                                    <FontAwesomeIcon icon={['fas', 'times']} size="lg" color='#000000' style={{ cursor: 'pointer' }} onClick={() => this.closeSelectModules()} />
                                </div>
                                <div className="row">
                                    <label className="overallCountText pl-2 pr-2" style={{ borderRight: '1px solid #000000' }}>Total Modules : <span className='font-weight-bold'>{totalModulesCount}</span></label>
                                    <label className="overallCountText pl-2">Subscribed Module Count :  <span className='font-weight-bold'>{clientSubscribedModulesCount}</span></label>
                                </div>
                                <div className="noteViewModuleeee w-100">
                                    <label className='noteTextttt mb-0'><span className='font-weight-bold'>Note : -</span> Please select the modules, their respective sub-modules, and the key features. Additionally select a phase for each module to organize the training into distinct phases.</label>
                                </div>
                            </div>
                            <div className="modal-body selectModules-body pt-0" style={{ height: '80vh' }}>
                                <div className="col-md-12 p-0 row">
                                    <div className="col-md-5 flex-column p-4 modulesContainer">
                                        <div className="row justify-content-between align-items-center">
                                            <div className="w-75 p-0 m-0 pr-2 ">
                                                <input
                                                    type="text"
                                                    className='form-control searchInputStyle w-100 pt-0 pb-0 mb-2'
                                                    placeholder='Search by module name'
                                                    value={searchKey}
                                                    onChange={(e) => this.setState({ searchKey: e.target.value }, () => this?.handleSearch())}
                                                />
                                            </div>
                                            <div className="w-25 p-0 m-0">
                                                <select
                                                    className='form-control searchInputStyle select-option w-100 mb-2'
                                                    value={filteredPhase}
                                                    onChange={(e) => this.setState({ filteredPhase: e.target.value }, () => this?.handleSearch())}
                                                >
                                                    <option className="" value="">Phase</option>
                                                    <option className="mb-0" value="phase1">Phase 1</option>
                                                    <option className="mb-0" value="phase2">Phase 2</option>
                                                    <option className="mb-0" value="phase3">Phase 3</option>
                                                    <option className="mb-0" value="phase4">Phase 4</option>
                                                    <option className="mb-0" value="phase5">Phase 5</option>
                                                </select>
                                            </div>
                                        </div>
                                        {
                                            modulesFetching ? <ButtonLoader /> :
                                                Object?.keys(mappingList)?.length > 0
                                                    ? Object?.keys(mappingList)?.map(moduleId => {
                                                        const isSelectedModule = filteredModuleId === moduleId;
                                                        const moduleInfo = mappingList[moduleId];
                                                        const isClientSubscribed = clientSubscribedModuleIds?.includes(parseInt(moduleId));
                                                        return (
                                                            <div className="row justify-content-between align-items-center" style={{ cursor: 'pointer' }} onClick={() => this.setState({ filteredModuleId: moduleId, filteredModuleName: moduleInfo?.module_name }, () => this.apiCallToGetHelpDeskModuleLSubmoduleListWithPoints())}>
                                                                <div className="w-75 p-0 m-0 pr-2 ">
                                                                    <div className="row mt-2 align-items-center p-2 pl-2" style={{ backgroundColor: isSelectedModule ? '#4694FF' : 'transparent', borderRadius: 5 }}>
                                                                        {
                                                                            isSelectedModule
                                                                                ?
                                                                                <img src={selectedIC} style={{ width: '5%', height: '5%' }} alt="" />
                                                                                : isClientSubscribed
                                                                                    ?
                                                                                    <img src={activeIc} style={{ width: '5%', height: '5%' }} alt="" />
                                                                                    :
                                                                                    <img src={inactiveIc} style={{ width: '5%', height: '5%' }} alt="" />

                                                                        }
                                                                        <FontAwesomeIcon className="ml-3" icon={['fas', moduleInfo?.font_awesome_icon]} size="md" color={isSelectedModule ? '#FFFFFF' : '#000000'} />
                                                                        <label className='mb-0 pl-3 moduleName' style={{ color: isSelectedModule ? '#FFFFFF' : '#000000', cursor: 'pointer' }}>{moduleInfo?.module_name}</label>
                                                                    </div>
                                                                </div>
                                                                <div className="w-25 p-0 m-0 pr-2">
                                                                    <select
                                                                        className='form-control searchInputStyle select-option pl-0 w-100 '
                                                                        style={{ border: 'none', backgroundColor: 'transparent' }}
                                                                        value={phaseDetails[moduleId]?.phase || ""}
                                                                        onChange={(e) => { }}
                                                                        disabled
                                                                    >
                                                                        <option className="mb-0" value="">Select Phase</option>
                                                                        <option className="mb-0" value="phase1">Phase 1</option>
                                                                        <option className="mb-0" value="phase2">Phase 2</option>
                                                                        <option className="mb-0" value="phase3">Phase 3</option>
                                                                        <option className="mb-0" value="phase4">Phase 4</option>
                                                                        <option className="mb-0" value="phase5">Phase 5</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    <label className='mb-0 pl-2 moduleName' style={{ color: '#000000' }}>No Modules</label>
                                        }
                                    </div>
                                    {
                                        filteredModuleId === ""
                                            ?
                                            <div className="h-25 row p-0 align-items-center ml-2 p-2 justify-content-center afterFocus" style={{ width: '56%', backgroundColor: 'transparent', border: '1px solid #7A7A7A', borderRadius: 5, justifySelf: 'center' }}>
                                                <label className='mb-0 pl-3 selectedHeader text-center' style={{ color: '#000000' }}>Please select module to continue.</label>
                                            </div>
                                            :
                                            <div className="col-md-7 focusRemoval">
                                                <div className="modulesContainer row align-items-center justify-content-between p-2 pl-4 pr-4 m-0">
                                                    <div className="row p-0 align-items-center afterFocus" style={{ width: '50%' }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ width: '4.9%' }}
                                                            className="form-control"
                                                            checked={updatedModuleDetails[filteredModuleId]}
                                                            onChange={(e) => this?.handleAllSelection(e)}
                                                            disabled
                                                        />
                                                        <FontAwesomeIcon className="m-0 ml-3" icon={['fas', 'user']} size="lg" color='#000000' />
                                                        <label className='mb-0 pl-3 selectedHeader' style={{ color: '#000000', width: '50%' }}>{module_name || filteredModuleName}</label>
                                                    </div>
                                                    <div className="flex-column p-0" style={{ width: '50%', textAlign: 'end' }}>
                                                        <label className='mb-0 pl-2 text-end selectedSubHeader' style={{ color: '#000000' }}>Total Sub-Modules : <span className='font-weight-bold'>{totalModuleIds || 0}</span></label>
                                                        <label className='mb-0 pl-2 text-end selectedSubHeader' style={{ color: '#000000' }}>Selected Sub-Modules Count : <span className='font-weight-bold'>{totalSelectedModuleIds || 0}</span></label>
                                                    </div>
                                                </div>

                                                {subModuleSequenceIdArray?.length > 0 && subModuleSequenceIdArray.map(subModuleId => {
                                                    const subModuleDetails = subModules[subModuleId];
                                                    const demoPointSequence = subModuleDetails?.demoPointSequence || [];
                                                    const checkSubmoduleParent = updatedModuleDetails[filteredModuleId] ? Object?.keys(updatedModuleDetails[filteredModuleId])?.includes(subModuleId?.toString()) : false;

                                                    return (
                                                        <div key={subModuleId} className='pl-3'>
                                                            <div className="row align-items-center justify-content-start pl-2 m-0" style={{ width: '80%' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    style={{ width: '2.9%' }}
                                                                    className="form-control"
                                                                    checked={checkSubmoduleParent}
                                                                    onChange={(e) => this.handleSubModuleSelection(e, subModuleId, demoPointSequence)}
                                                                    disabled
                                                                />
                                                                <label className='mb-0 pl-2 selectedSubModule' style={{ color: '#000000', width: '50%' }}>{subModuleDetails?.module_name}</label>
                                                            </div>
                                                            {demoPointSequence.map(demoId => {
                                                                const demoObj = subModuleDetails?.demo_point[demoId];
                                                                const checkSubmoduleParent = updatedModuleDetails[filteredModuleId] ? updatedModuleDetails[filteredModuleId][subModuleId]?.includes(demoId) : false;
                                                                return (
                                                                    <div key={demoId} className=" ml-4 row align-items-center justify-content-start pl-2 m-0" style={{ width: '50%' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ width: '4.9%' }}
                                                                            className="form-control"
                                                                            checked={checkSubmoduleParent}
                                                                            onChange={() => this.handleDemoIdSelection(subModuleId, demoId)}
                                                                            disabled
                                                                        />
                                                                        <label className='mb-0 pl-2 selectedSubModule' style={{ color: '#000000', width: '50%' }}>{demoObj?.point?.replace(/<[^>]*>?/gm, '')}</label>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return <></>
        }
    }

    // METHOD TO CLOSE SELECT MODULES MODAL
    closeSelectModules = () => {
        this.setState({
            selectModules: false,
            updatedModuleDetails: {},
            filteredModuleName: "",
            selectedModuleIds: [],
            filteredModuleId: "",
            filteredPhase: "",
            moduleDetails: {},
            searchKey: "",
        });
    }

    render() {
        const { showLiveUpdateView } = this.state;
        const { completedVisits, subscriptionType, totalVisits } = this.state;
        const customizationProcess = [
            {
                phase: "Phase I",
                phaseTitle: "Requirement",
                points: [
                    {
                        title: "Gather, analyze, and document software requirements.",
                        desc: "We collect and examine all the software needs and specifications before documenting them for clarity and reference, ensuring we understand exactly what's required for the project."
                    },
                    {
                        title: "Define functional and non-functional requirements.",
                        desc: "We identify what the software needs to do (functional requirements) and how it should perform (non-functional requirements), ensuring clear goals for development."
                    }
                ]
            },
            {
                phase: "Phase II",
                phaseTitle: "Planning",
                points: [
                    {
                        title: "Define requirement scope, objectives, resources, and timelines",
                        desc: "We outline what needs to be achieved, who will be involved, and when it will be completed, ensuring clarity and alignment before proceeding further."
                    },
                    {
                        title: "Establish feasibility and create a project plan.",
                        desc: "Establish feasibility involves determining if the customization is possible within technical and resource constraints. Creating a project plan outlines the scope, objectives, resources, and timelines for the customization project."
                    }
                ]
            },
            {
                phase: "Phase III",
                phaseTitle: "Design",
                points: [
                    {
                        title: "Create system architecture",
                        desc: "Creating system architecture involves designing the overall structure and layout of the software, including how different components interact with each other to ensure smooth functioning."
                    },
                    {
                        title: "Database design",
                        desc: "Database design involves creating the structure and organization of data storage, ensuring efficient retrieval and management."
                    },
                    {
                        title: "UI/UX design creation",
                        desc: "UI/UX design creation involves crafting the visual layout and user interaction of the software to enhance usability and provide an intuitive experience for users. It focuses on creating aesthetically pleasing interfaces and intuitive navigation paths to optimize user satisfaction."
                    },
                    {
                        title: "Other detailed technical specifications.",
                        desc: ""
                    },
                ]
            },
            {
                phase: "Phase IV",
                phaseTitle: "Development",
                points: [
                    {
                        title: "Write code based on design specifications",
                        desc: "In this step, developers write code according to the design specifications outlined previously, ensuring that the software functions as intended and meets the client's requirements."
                    },
                    {
                        title: "Develop and integrate the required components ",
                        desc: "Develop and integrate the required components involves creating the necessary features and incorporating them seamlessly into the existing system to enhance functionality and user experience."
                    },
                    {
                        title: "Test individual components or modules.",
                        desc: "Testing individual components or modules involves checking each part of the software to ensure it works correctly on its own before integrating them together. This step helps identify and fix any issues early in the development process."
                    },
                ]
            },
            {
                phase: "Phase V",
                phaseTitle: "Testing",
                points: [
                    {
                        title: "Conduct various types of testing such as,",
                        desc: ""
                    },
                ]
            },
            {
                phase: "Phase VI",
                phaseTitle: "Deployment",
                points: [
                    {
                        title: "Deploy the software to the production environment",
                        desc: "Deploying the software means making it available for use by either placing it in the production environment or distributing it to specific users."
                    },
                    {
                        title: "Configure and optimize system settings",
                        desc: "It involve adjusting software parameters and fine-tuning performance for optimal operation."
                    },
                ]
            },
            {
                phase: "Phase VII",
                phaseTitle: "Maintenance",
                points: [
                    {
                        title: "Provide ongoing support, bug fixes, updates, and enhancements.",
                        desc: "Continuously support and improve software by fixing bugs, updating features, and enhancing performance."
                    },
                    {
                        title: "Monitor performance and user feedback.",
                        desc: ""
                    },
                ]
            },
        ]
        return (
            <>
                <div className="container-fluid queryComponentContainer py-1">
                    <div className='heading row justify-content-between align-items-center p-0 pt-1 pb-1 mb-3' style={{ boxShadow: 'none' }}>
                        <div className="row justify-content-center align-items-center">
                            {showLiveUpdateView && (
                                <div className="backArrowBg mr-3" onClick={this.closeLiveUpdatesView}>
                                    <FontAwesomeIcon icon={['fas', 'chevron-left']} size="md" color="#000" style={{ cursor: "pointer" }} />
                                </div>
                            )}
                            <p className='font-weight-bold vm_custom_body1'>{showLiveUpdateView ? "Release Updates Dashboard" : "Service Requests"}</p>
                        </div>
                        {!showLiveUpdateView && (
                            <div className="row d-flex justify-content-end align-item-end mr-4">
                                <span className='' style={{ width: '4vw', alignSelf: 'center' }}>
                                    <img className='img-fluid' src={viewBTNGif} style={{ width: '80%' }} />
                                </span>
                                <div className="btn liveUpdateBtn" style={{ cursor: 'pointer' }} onClick={this.openLiveUpdatesView}>
                                    <p className='liveUpdateText'>View Live updates</p>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-mdd-12 cardContainer m-3">
                        <div className="row justify-content-between align-items-center pl-3 pr-3">
                            <div className="row align-items-center">
                                {/* <div className="dotStyling mr-3"></div> */}
                                <img className='img-fluid' src={animatedDot} style={{ width: '2.5%' }} />
                                <label className="mb-0 ml-1 subscriptionDetails">Subscription Details</label>
                            </div>
                            {
                                subscriptionType?.toLowerCase() == "premium" ? (
                                    <div className="row align-items-center">
                                        <img src={premiumIC} className='mr-2' alt="" style={{ width: 25, height: 22 }} />
                                        <label className=" subscriptionType mb-0" style={{ color: '#F39C12' }}>Premium Subscription</label>
                                    </div>
                                ) : subscriptionType?.toLowerCase() == "enterprise" ? (
                                    <div className="row align-items-center">
                                        <img src={enterpriseIC} className='mr-2' alt="" style={{ width: 25, height: 22 }} />
                                        <label className="mb-0 subscriptionType" style={{ color: '#27AE60' }}>Enterprise Subscription</label>
                                    </div>
                                ) : subscriptionType?.toLowerCase() == "classic" && (
                                    <div className="row align-items-center">
                                        <img src={classicIC} className='mr-2' alt="" style={{ width: 25, height: 22 }} />
                                        <label className="mb-0 subscriptionType">Classic Subscription</label>
                                    </div>
                                )
                            }
                        </div>
                        <div className="row justify-content-between align-items-center p-1 pb-0 pr-0">
                            <label className="mb-0 visitText "><span className='font-weight-bolder'>{completedVisits}/{totalVisits}</span> Number of Free On-site Visits</label>
                            <div className="bar"></div>
                            <label className="mb-0 visitTextWithBorder ">Software customization on priority basis is not committed as per the agreement.</label>
                            <div className="bar"></div>
                            <label className="mb-0 visitTextWithBorderLink " onClick={() => this.setState({ selectModules: true })}>View Subscribed Modules</label>
                            <div className="bar"></div>
                            <label className="mb-0 visitTextWithBorderLink " onClick={() => this.setState({ isOpenAccordion: !this.state.isOpenAccordion })}>View Customization Process</label>
                        </div>
                        <div className="accordionContainer w-100 mt-2" style={{ display: this.state.isOpenAccordion ? 'block' : 'none' }}>
                            <div className="p-3">
                                <div className="row w-100 justify-content-between align-items-center">
                                    <label htmlFor="" className="accordionHeader">After a service request is raised from the Help Desk, here’s how the Customization Process works!</label>
                                    <FontAwesomeIcon icon={['fas', 'chevron-up']} size="md" color='#4D4D4D' style={{ cursor: 'pointer' }} onClick={() => this.setState({ isOpenAccordion: false })} />
                                </div>
                                <label htmlFor="" className="accordionSubHeader mt-1" style={{ width: '92%' }}>Customization requests take time because we follow a thorough process to ensure quality and efficiency. This involves planning, gathering requirements, designing, implementing, testing, deploying, and maintaining the changes. Each step is essential for delivering the best possible outcome.</label>
                            </div>
                            {
                                customizationProcess?.map((process, index) => (
                                    <div key={index} className="col-md-12 row cardContainer-accordion mb-2 p-3 w-100">
                                        <div className="col-md-4 d-flex flex-column">
                                            <label htmlFor="" className="phaseNo">{process?.phase}</label>
                                            <label htmlFor="" className="phaseTitle">{process?.phaseTitle}</label>
                                        </div>
                                        <div className="d-flex flex-column col-md-8">
                                            {process?.points?.map((point, index) => (
                                                <div key={index} className="contentSide">
                                                    <FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon" color='#000000' style={{ marginTop: 10 }} />
                                                    <div className="ml-2 mt-1">
                                                        <label className="pointTitle mb-0">{point?.title}</label>
                                                        {
                                                            process?.phaseTitle != "Testing"
                                                                ?
                                                                (
                                                                    <p className="pointDesc mt-1">{point?.desc}</p>
                                                                )
                                                                :
                                                                (
                                                                    <>
                                                                        <p className="pointDesc mt-1">1. Unit Texting</p>
                                                                        <p className="pointDesc">2. Integration testing</p>
                                                                        <p className="pointDesc">3. System testing</p>
                                                                        <p className="pointDesc">4. Acceptance testing.</p>
                                                                        <p className="pointDesc">to ensure our software meets quality standards at every level before deployment.</p>
                                                                    </>
                                                                )
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))
                            }

                            <div className="col-md-12 mt-3 d-flex flex-column">
                                <div className="row align-items-center">
                                    <div className="verticalBar"></div>
                                    <label htmlFor="" className="quesText text-center mb-0 ml-2">How To Achieve Software Customization?</label>
                                </div>
                                <label className="subQuesText mb-0 ml-3">User Raises Query:</label>
                                <label className="subQuesText mb-0 ml-4"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> User submits a customization query regarding our software.</label>
                                <label className="subQuesText mb-0 ml-3">1. Query Validation:</label>
                                <label className="subQuesText mb-0 ml-4"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> Our team validates the query to ensure it aligns with customization guidelines.</label>
                                <label className="subQuesText mb-0 ml-3">2. Development Process:</label>
                                <label className="subQuesText mb-0 ml-4"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> Valid queries proceed to the development phase where our team works on implementing the requested customization.</label>
                                <label className="subQuesText mb-0 ml-3">3. Release Preparation:</label>
                                <label className="subQuesText mb-0 ml-4"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> Customizations are bundled into a software release, along with other enhancements and updates.</label>
                                <label className="subQuesText mb-0 ml-3">4. Release Document:</label>
                                <label className="subQuesText mb-0 ml-4"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> When the release drops, users can access the release document which details all resolved queries and enhancements.</label>
                                <label className="subQuesText mb-0 ml-3">5. Query Resolution:</label>
                                <label className="subQuesText mb-0 ml-4"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> Users can view their query details in the release document and see how the software has been enhanced.</label>
                                <label className="subQuesText mb-0 ml-3">5. Product Enhancement:</label>
                                <label className="subQuesText mb-0 ml-4"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> With the release, users can use the enhanced version of the software with their requested customizations implemented.</label>
                            </div>
                            <div className="col-md-12 mt-3 d-flex flex-column justify-content-center">
                                <div className="row align-items-center">
                                    <div className="verticalBar"></div>
                                    <label htmlFor="" className="quesText text-center mb-0 ml-2">Why Online Training Is Recommended? </label>
                                </div>
                                <label htmlFor="" className="subQuesText ml-3"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> Our experience has shown that online training consistently delivers superior results and higher user satisfaction compared to on-site visits.</label>
                                <label htmlFor="" className="subQuesText ml-3"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> Online training is recommended as it provides convenient access to hands-on demonstrations of our product modules.</label>
                                <label htmlFor="" className="subQuesText ml-3"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> This allows our executives to efficiently guide you through the features and functionalities remotely.</label>
                                <label htmlFor="" className="subQuesText ml-3"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> Following the online training, an on-site visit can be arranged for further assistance and personalized support.</label>
                            </div>
                            <div className="col-md-12 mt-3 d-flex flex-column justify-content-center">
                                <div className="row align-items-center">
                                    <div className="verticalBar"></div>
                                    <label htmlFor="" className="quesText text-center mb-0 ml-2">Why Software Customizations Are Never Ending Process? </label>
                                </div>
                                <label htmlFor="" className="subQuesText ml-3"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> Software customization is an ongoing process due to evolving needs and advancements.</label>
                                <label htmlFor="" className="subQuesText ml-3"><span><FontAwesomeIcon icon={['fa', 'circle']} className="extra-small-icon pb-1" color='#000000' style={{ marginTop: 10 }} /></span> As technology and requirements change, continual adjustments and updates are necessary to ensure the software meets your specific needs effectively.</label>
                            </div>
                        </div>
                    </div>
                    {
                        showLiveUpdateView ? this.liveUpdateView() : (
                            <div className='d-flex px-3 py-2' style={{ gap: "10px" }}>
                                <div className=' scrollable-container' style={{ width: "20%", }}>
                                    <div className='d-flex flex-column scrollable-content' style={{ gap: "6px", height: "74vh" }}>
                                        {
                                            Object.values(this.state.subscriptionModuleList).length > 0 &&

                                            Object.values(this.state.subscriptionModuleList)
                                                .filter(el => el.module_name !== 'Help Desk')
                                                .map((el, i) =>
                                                    <div className={this.state.selectedModuletab == el.module_name ? "tabdivActive" : 'tabdiv'} key={i}
                                                        onClick={() => this.setState({ selectedModuletab: el.module_name, moduleId: el.unique_id, filterServiceRequest_Number: "", pageIndex: 1, sevicePageIndex: 1 }, () => this.apiCallToGetQueries().then(() => this.apiCallToGetServiceReqQuery()).then(() => this.apiCallToGetAddSubModuleList()))}
                                                    >

                                                        <div className='imgdiv'>
                                                            <FontAwesomeIcon icon={['fas', `${el.font_awesome_icon}`]} color={this.state.selectedModuletab == el.module_name ? "white" : 'black'} style={{ cursor: 'pointer', fontSize: '16px' }} />
                                                        </div>
                                                        <div className='d-flex flex-column justify-content-center'>
                                                            <p style={{ fontWeight: "bold", fontSize: "14px" }}>{el.module_name}</p>
                                                        </div>
                                                        {/* I need filter accordsding to ccList */}
                                                        {
                                                            Object.keys(this.state.ccList).map((cc) => (
                                                                cc == el.unique_id && (
                                                                    <img alt='ccList' style={{ width: 18, height: 18, marginLeft: 5, marginRight: 5 }} src={alarmGif} />

                                                                )

                                                            )



                                                            )
                                                        }


                                                    </div>
                                                )
                                        }
                                    </div>
                                </div>


                                <div style={{ width: "80%" }}>

                                    <div className='subModule'>
                                        <p>{this.state.selectedModuletab}</p>
                                    </div>

                                    <div className='d-flex' style={{ gap: "10px", marginTop: "5px" }}>

                                        <div style={{ width: "55%" }}>

                                            <div className='recentUpdt'>
                                                <p>Recent Updates</p>
                                            </div>


                                            <div className='heigthForFirstDiv' style={{ display: "flex", flexDirection: "column", overflowY: "scroll" }}>


                                                {
                                                    this.state.queryListFetching ?
                                                        <Spinner />
                                                        :
                                                        Object.values(this.state.queryList).length > 0 ?
                                                            <div>
                                                                {Object.values(this.state.queryList).map((query, index) => (
                                                                    <div className='queryDetail' key={index} style={{}}>
                                                                        <p style={{ fontSize: "14px" }}>{ReactHtmlParser(query.description)}</p>
                                                                        <p style={{ color: "#6B6B6B", fontSize: "12px" }}>Posted on: {query.date}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            :
                                                            <p style={{ fontSize: "14px" }}>No recent updates</p>
                                                }
                                            </div>

                                            {
                                                Object.values(this.state.queryList).length > 0 &&
                                                <div id="paginationContainer">
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.queryCount}
                                                        pageRangeDisplayed={3}
                                                        onChange={(num) => this.updatePageForUpdates(num)}
                                                    />
                                                </div>}
                                        </div>

                                        <div style={{ width: "45%", marginTop: "1px", }}>
                                            <div className='servicereq'>
                                                <p>Service Requests</p>
                                                {
                                                    this.state.checkingInstituteStatus ?
                                                        <ButtonLoader />
                                                        :
                                                        <FontAwesomeIcon onClick={() => this.apiCallToCheckUserStatus()} icon={['fas', 'plus']} style={{ cursor: 'pointer', fontSize: '14px', color: 'gray' }} />
                                                }
                                            </div>

                                            <div class="search-box">
                                                <input style={{ width: "100%", }}
                                                    type="number"
                                                    id="serchtags"
                                                    value={this.state.filterServiceRequest_Number}
                                                    onChange={(e) => this.setState({ filterServiceRequest_Number: e.target.value })}
                                                    placeholder="Search by service request id and press enter"
                                                    onKeyPress={(e) => this.onEnterCall(e)}
                                                />
                                                <FontAwesomeIcon icon={['fas', 'search']} size="sm" color='#939393' class="searchtag" style={{ cursor: 'pointer' }} />

                                            </div>

                                            <div className='d-flex heigthForDiv' style={{ overflowY: "scroll", flexDirection: "column" }}>

                                                {this.state.serviceReqFetch ?
                                                    <Spinner />
                                                    :
                                                    Object.keys(this.state.serviceReqList).length > 0 ?

                                                        this.state.serviceReqSequence.map((queryId, index) => {
                                                            let query = this.state.serviceReqList[queryId];


                                                            return (
                                                                <>
                                                                    <div className='serviceQuery' key={index}>
                                                                        <div className='d-flex justify-content-between'>
                                                                            <div className='d-flex align-items-center' style={{ gap: "10px" }}>
                                                                                <div>
                                                                                    {
                                                                                        query.query_occurred_in == "IOS Application" ?
                                                                                            <FontAwesomeIcon icon={['fab', 'apple']} size="md" color='black' />
                                                                                            :
                                                                                            query.query_occurred_in == "Android Application" ?
                                                                                                <FontAwesomeIcon icon={['fab', 'android']} size="sm" color='black' />

                                                                                                :
                                                                                                <FontAwesomeIcon icon={['fas', 'desktop']} size="sm" color='black' />

                                                                                    }
                                                                                </div>
                                                                                <p className='vm_custom_body4'>{query.uniqueid}</p>
                                                                                {(query?.isRequestApprovalPendingByClient && query.isRequestApprovalPendingByClient == 'true') &&
                                                                                    <img style={{ width: 18, height: 18, marginLeft: 5, marginRight: 5 }} src={alarmGif} />


                                                                                }
                                                                            </div>


                                                                            {/* <span>{query.userQuery)</span>
                                                                                 */}
                                                                            {/* create small badge span */}
                                                                            {/* <div style={{ textAlign: 'center' }}>
                                                                                <span
                                                                                    className="vm_custom_body8"
                                                                                    style={{
                                                                                        backgroundColor: "#F8FDF7",
                                                                                        border: "1px solid #80BF80",
                                                                                        borderRadius: "50px",
                                                                                        padding: "2px 5px",
                                                                                        color: "#000000"
                                                                                    }}
                                                                                >
                                                                                    {query.userQueryType.charAt(0).toUpperCase() + query.userQueryType.slice(1)}
                                                                                </span>
                                                                            </div> */}

                                                                        </div>


                                                                        <p className='vm_custom_body10 text-wrap' style={{ fontSize: "14px", marginTop: "2px", maxWidth: '80%', wordBreak: 'break-all' }}>{ReactHtmlParser(query.userQuery)}</p>

                                                                        <div className='d-flex justify-content-between pr-2'>
                                                                            <p className='vm_custom_body6' style={{ color: "#888888" }}>{query.accountType !== "" ? `${query.accountType} Account` : ""}</p>
                                                                            <p
                                                                                className="vm_custom_body3"

                                                                                style={{ color: "#2F80ED", textDecoration: "underline", cursor: "pointer" }}
                                                                                onClick={() => this.viewQueryDetails(query, query.uniqueid, 'query')}
                                                                            >
                                                                                View
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })
                                                        :
                                                        <p style={{ fontSize: "14px" }}>Currently, there are no raised service requests here.</p>
                                                }
                                            </div>

                                            {Object.values(this.state.serviceReqList).length > 0 &&
                                                <div id="paginationContainer">
                                                    <Pagination
                                                        activePage={this.state.sevicePageIndex}
                                                        itemsCountPerPage={this.state.serviceLimit}
                                                        totalItemsCount={this.state.serviceReqCount}
                                                        pageRangeDisplayed={3}
                                                        onChange={(num) => this.updateServicePage(num)}
                                                    />
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
                {
                    this.state.openQueryModal && <ViewRequestModal
                        userQueryType={this.state.userQueryType}
                        isCCAdminMember={this.state.isCCAdminMember}
                        selectedModuleName={this.state.selectedModuletab}
                        selectedModuleId={this.state.moduleId}
                        srId={this.state.currentQueryRequestId}
                        currentRequest={this.state.currentRequest}
                        openServiceRequestModal={this.state.openQueryModal}
                        onCloseModal={this.handleCloseViewRequestModal}
                    />
                }
                {
                    // this.returnAddQuery()
                    this.state.addQuery && <AddRequestModal
                        selectedModuleName={this.state.selectedModuletab}
                        selectedModuleId={this.state.moduleId}
                        openExecutiveResponse={this.state.addQuery} onCloseModal={this.handleCloseServiceRequestModal} />
                }
                {
                    this.returnViewQuery()
                }
                {
                    this.returnViewModule()
                }
                {
                    this.returnViewAttachment()
                }
                {
                    this.renderViewSprintModal()
                }
                {
                    this.returnResolveConfirmationModal()
                }
                {
                    this.returnReopenConfirmationModal()
                }
                {
                    this.returnSelectModules()
                }
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
            </>
        );
    }
}
QueryDetails.modules = {
    toolbar: [
        [
            "bold",
            "italic",
            "underline",
            "strike",
            { align: [] },
            { script: "sub" },
            { script: "super" },
            { list: "ordered" },
            { list: "bullet" },

        ], // toggled buttons

    ],

    clipboard: {
        matchVisual: false,
    },
};

QueryDetails.formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline',
    'list', 'bullet',
    'link', 'image',
];

export default QueryDetails;